import { StringsType } from "./StringsKeys";

const fr: StringsType = {
  open: "Ouvrir",
  import: "Importer",
  french: "Français",
  english: "Anglais",
  hello: "Bonjour",
  dashboard: "Tableau de bord",
  createAccount: "Créer un compte",
  createClient: "Créer un client",
  clientName: "Nom du Client",
  clientEmail: "Email du Client",
  clientPhone: "Téléphone du Client",
  customerSince: "Client Depuis",
  clientStatus: "Statut du Client",
  riskLevel: "Niveau de Risque",
  risk: "Risque",
  profileRating: "Évaluation du Profil",
  consolidatedBalance: "Solde Consolidé",
  folderStatus: "Statut du Dossier",
  completionPercentage: "Pourcentage de Complétion",
  lastUpdated: "Dernière Mise à Jour",
  actions: "Actions",
  viewDetails: "Voir les Détails",
  details: "Détails",
  compare: "Comparer",
  edit: "Modifier",
  delete: "Supprimer",
  assignAdvisor: "Assigner un Conseiller",
  updateRiskLevel: "Mettre à Jour le Niveau de Risque",
  searchClients: "Rechercher des clients...",
  filterByAgency: "Filtrer par Agence",
  filterByStatus: "Filtrer par Statut",
  filterByRiskLevel: "Filtrer par Niveau de Risque",
  filterByAdvisor: "Filtrer par Conseiller",
  allAgencies: "Toutes les Agences",
  allStatuses: "Tous les Statuts",
  allRiskLevels: "Tous les Niveaux de Risque",
  allAdvisors: "Tous les Conseillers",
  active: "Actif",
  inactive: "Inactif",
  dormant: "Dormant",
  moderate: "Modéré",
  high: "Élevé",
  veryHigh: "Très Élevé",
  low: "Faible",
  assigned: "Assigné",
  unassigned: "Non Assigné",
  totalClients: "Total des Clients",
  activeClients: "Clients Actifs",
  highRiskClients: "Clients à Risque Élevé",
  unassignedClients: "Clients Non Assignés",
  totalPortfolioValue: "Valeur Totale du Portefeuille",
  averageProfileRating: "Évaluation Moyenne du Profil",
  loadingClients: "Chargement des clients...",
  noClientsFound: "Aucun client trouvé",
  clientDetails: "Détails du Client",
  accountInformation: "Information sur le compte",
  clientInformation: "Information sur le Client",
  applicantContactDetails: "Coordonnées du demandeur",
  incomeInformation: "Information sur les revenus",
  accountType: "Type de compte",
  fullName: "Nom complet",
  businessKey: "Business Key",
  dateOfBirth: "Date de naissance",
  phone: "Téléphone",
  incomeSource: "Source de revenus",
  requiredDocuments: "Documents requis",
  documentsPending: "Documents en attente",
  uploadAllDocuments: "Importer tous les documents",
  documentRequired: "Document requis",
  documentOptional: "Document optionnel",
  upload: "Importer",
  documentsProcessed: "Documents traités",
  progress: "Progression",
  loadingDocuments: "Chargement des documents...",
  documentLoadingError: "Erreur lors du chargement des documents requis",
  retryLoadingDocuments: "Réessayer",
  addNewClient: "Ajouter un Nouveau Client",
  exportData: "Exporter les Données",
  refreshData: "Actualiser les Données",
  percent: "%",
  documents: "Documents",

  // Form Steps
  personalInformation: "Informations personnelles",
  contactAddressDetails: "Coordonnées et adresse",
  professionalFamilyInformation: "Informations professionnelles et familiales",
  professionalInformation: "Informations professionnelles",
  familyInformation: "Informations familiales",
  summary: "Résumé",

  // Personal Information Fields
  name: "Nom",
  lastName: "Nom de famille",
  firstName: "Prénom(s)",
  motherFullName: "Nom complet de la mère",
  nationality: "Nationalité",
  spokenLanguage: "Langue parlée",
  gender: "Genre",
  male: "Masculin",
  female: "Féminin",
  documentType: "Type de document",

  // Contact Details Fields
  mobilePhone: "Téléphone mobile",
  email: "Email",
  homePhone: "Téléphone fixe",
  countryOfResidence: "Pays de résidence",
  cityMunicipality: "Ville/Commune",
  address: "Adresse",
  postalAddressBP: "Adresse postale (BP)",
  geographicalLandmark: "Point de repère géographique",
  postalBox: "Boîte postale",
  postalCode: "Code postal",

  // Professional Information Fields
  isOwner: "Êtes-vous propriétaire ?",
  monthlyIncome: "Revenu mensuel",
  hasOtherIncome: "Autres revenus ?",
  otherIncomeAmount: "Montant des autres revenus",
  professionalCategory: "Catégorie professionnelle",
  profession: "Profession",
  employer: "Employeur",
  officePhone: "Téléphone du bureau",
  educationLevel: "Niveau d'éducation",
  maritalStatus: "Situation matrimoniale",
  numberOfChildren: "Nombre d'enfants",
  partnerFirstName: "Prénom du conjoint(e)",
  partnerLastName: "Nom du conjoint(e)",
  fatherLastName: "Nom du père",
  fatherFirstName: "Prénom du père",
  motherMaidenName: "Nom de jeune fille de la mère",
  motherFirstName: "Prénom de la mère",
  countryOfBirth: "Pays de naissance",
  dependents: "Personnes à charge",

  // Form Validation Messages
  fieldRequired: "Ce champ est requis",
  fieldLimited: "Ce champ est limité à 50 caractères",
  validName: "Ce champ doit contenir au moins 3 caractères",
  phoneNumberInvalid: "Numéro de téléphone invalide",
  invalidEmailFormat: "Format d'email invalide",
  mustBeGreaterThanZero: "Doit être supérieur à 0",
  otherIncomeRequired:
    "Le montant des autres revenus est requis quand d'autres revenus sont sélectionnés",

  // Form Status Messages
  formCompleteReady: "Formulaire complet et prêt à être soumis",
  formIncompleteReview: "Formulaire incomplet - Veuillez vérifier",
  formCompleteMessage:
    "Tous les champs requis ont été remplis. Vous pouvez maintenant soumettre le formulaire.",
  formIncompleteMessage:
    "Certains champs requis sont manquants ou incomplets. Veuillez revenir en arrière et compléter tous les champs requis avant de soumettre.",

  // Navigation
  previous: "Précédent",
  next: "Suivant",
  paginationPageSize: "par page",
  paginationPageInfo: "Page {current} / {total}",
  submit: "Soumettre",
  submitting: "Soumission en cours...",
  back: "Retour",

  // Form Steps Description
  personalInfoDescription: "Nom, Prénom(s), genre, nationalité...",
  contactInfoDescription: "Adresse, Téléphone, Email",
  professionalInfoDescription: "Revenus, actifs, état civil",
  summaryDescription: "Vérifiez toutes les informations avant soumission",

  // Currency
  currency: "F CFA",

  // Placeholders
  placeholderLastName: "Ex: KOUASSI",
  placeholderFirstName: "Ex: Bernard",
  placeholderMotherName: "Ex: Bernardette KOUASSI",
  placeholderEmail: "Ex: mail@gmail.com",
  placeholderAddress: "Ex: Côte d'Ivoire, Abidjan, Cocody, Cité Verdoyante",
  placeholderLandmark: "Ex: Riviera 2, Anono, Près de, En face de...",
  placeholderProfession: "Ex: Testeur",
  placeholderEmployer: "Ex: BOX AFRICA",

  // Cities
  abidjan: "Abidjan",
  yamoussoukro: "Yamoussoukro",
  bouake: "Bouaké",
  sanPedro: "San-Pédro",
  korhogo: "Korhogo",
  man: "Man",
  gagnoa: "Gagnoa",
  daloa: "Daloa",

  // Other
  other: "Autre",
  notProvided: "Non fourni",
  yes: "Oui",
  no: "Non",
  administration: "Administration",
  rolesAndPermissions: "Rôles & Permissions",
  users: "Utilisateurs",
  attestations: "Attestations",
  offboarding: "Offboarding",
  jitAccess: "Accès JIT",
  settings: "Paramètres",
  sodRules: "Règles SoD",
  adMapping: "Mappages AD",
  runtimeDecisions: "Décisions Runtime",
  enterprise: "Enterprise",
  expired: "Expiré",
  newRole: "Nouveau rôle",
  role: "Rôle",
  newRequest: "Nouvelle demande",
  publishRole: "Publier un rôle",
  publishRoleAttestation:
    "J’atteste que ce rôle est conforme aux politiques de sécurité et de conformité",
  publishingRole: "Publication du rôle...",
  rolePublishedSuccess: "Le rôle a été publié avec succès.",
  rolePublishedError: "La publication du rôle a échoué.",
  confirmPublishRoleTitle: "Confirmer la publication du rôle",
  confirmPublishRoleDescription:
    "Cette action publiera définitivement ce rôle et le rendra disponible en production.",
  simulateUser: "Simuler utilisateur",
  mapAD: "Mapper AD",
  save: "Enregistrer",
  search: "Recherche",
  selectValue: "Sélectionner une valeur...",
  searchValue: "Rechercher une valeur...",
  noValueFound: "Aucune valeur trouvée.",
  prospectsSearch: "Nom, email, téléphone, ...",
  prospectsSearchSection: "Rechercher un prospect",
  prospectsSearchFilters: "Affiner le pipeline",
  prospectsShowFilters: "Afficher la recherche",
  prospectsHideFilters: "Masquer la recherche",
  statusProspect: "Prospect",
  statusPendingScreening: "En revue conformité (L1/EDD)",
  statusRefused: "Refusé",
  statusFilterHelp: "Ce que chaque statut signifie",
  statusProspectHint:
    "Dossier en cours de constitution, pas encore enregistré comme client. Affiché avec les deux autres statuts quand aucun filtre n'est choisi.",
  statusPendingScreeningHint:
    "Prospect déjà screené et enregistré au référentiel mais sans compte bancaire, en attente d'une décision de revue conformité (L1 ou EDD 4-yeux). Le compte est créé à l'approbation de la revue.",
  statusRefusedHint:
    "Revue défavorable : le prospect reste enregistré, aucun compte n'est créé. La conformité peut remettre le dossier à l'étude, il repasse alors en attente de screening.",
  typeFilterHelp: "Ce que chaque segment recouvre",
  physicalPersonHint:
    "Particulier. C'est le segment de la très grande majorité des dossiers, affiché « PP » dans la liste.",
  legalPersonHint:
    "Entreprise ou organisation, affichée « PM ». Son dossier porte en plus une identité légale (forme juridique, RCCM) et ses personnes liées.",
  channelFilterHelp: "Par quelle voie le dossier est entré en relation",
  channelDigitalHint:
    "Ouvert à distance par le parcours self-onboarding, sans passage en agence ni vérification biométrique. Le scoring en tient compte.",
  channelAgencyHint:
    "Créé en agence par un conseiller, avec vérification biométrique du client.",
  channelCbsImportHint:
    "Client déjà connu du core banking, repris dans le référentiel par synchronisation et non créé ici.",
  channelWhatsappHint:
    "Ouvert à distance via WhatsApp Banking, sans passage en agence ni vérification biométrique. Même niveau de risque que le canal Digital.",
  periodCreated: "Période de création",
  periodFilterHelp: "Comment la période est appliquée",
  periodFilterHint:
    "Filtre sur la date de création du dossier. Les deux bornes sont incluses : du 1er au 1er rend bien les dossiers créés ce jour-là. La liste n'est filtrée qu'une fois les deux dates choisies.",
  channelDigital: "Digital",
  channelAgency: "Agence",
  channelCbsImport: "Repris du core banking",
  channelWhatsapp: "WhatsApp",
  prospectsSearchFiltersHint:
    "Filtrez les prospects par type, statut et canal de création.",
  reset: "Réinitialiser",
  results: "Résultats",
  status: "Statut",
  criticality: "Criticité",
  frequency: "Cadence",
  sod: "SoD",
  help: "Aide",
  views: "Vues",
  generalInformation: "Informations générales",
  prefilledFromCreationStep:
    "Déjà renseigné à la création du prospect. Cliquez sur Modifier pour corriger.",
  matrixViewDescription: "Vue matricielle des rôles et permissions",
  usersDescription: "Gérez les utilisateurs de la plateforme",
  usersSearchHint: "Nom, login ou email",
  roleAndOwner: "Rôle & Owner",
  archived: "Archivé",
  draft: "Brouillon",
  published: "Publié",
  none: "Aucun",
  twoSod: "2 SoD →",
  consult: "Consulter",
  modify: "Modifier",
  approve: "Approuver",
  export: "Exporter",
  compliance: "Conformité",
  credit: "Crédit",
  gdpr: "RGPD",
  linesPerPage: "Lignes par page",
  pageInfo: "Page 1 sur 8",
  notifications: "Notifications",
  noNotifications: "Aucune notification",
  noNotificationsHint:
    "Les alertes sur vos dossiers, la conformité et l'administration s'afficheront ici.",
  notificationsUnread: "{{count}} non lue(s)",
  notificationsTabAll: "Toutes",
  notificationsTabUnread: "Non lues",
  notificationsEmptyUnread: "Aucune notification non lue",
  notificationsToday: "Aujourd'hui",
  notificationsYesterday: "Hier",
  notificationsEarlier: "Plus anciennes",
  markAllAsRead: "Tout lire",

  // Form Steps Title
  formSteps: "Étapes du formulaire",
  fillInInformation: "Remplissez les informations",

  // Error Messages
  pleaseFixErrors: "Veuillez corriger les erreurs suivantes :",
  failedToSubmit: "Échec de la soumission du formulaire. Veuillez réessayer.",
  formSubmittedSuccessfully: "Formulaire soumis avec succès !",
  contactInfoUpdated: "Les coordonnées ont été mises à jour avec succès.",

  // Step Status
  current: "actuel",
  completed: "terminé",
  pending: "en attente",
  error: "erreur",

  failedGettingUserRole: "Échec de la récupération du rôle de l'utilisateur",
  backToHome: "Retour à l'accueil",
  pageNotFound: "Page non trouvée",
  WeCouldNotFindThePageYouAreLookingFor:
    "Nous n'avons pas pu trouver la page que vous recherchez.",
  internalServerError:
    "Le serveur rencontre des difficultés temporaires. Veuillez réessayer plus tard.",
  oopsSomethingWentWrong: "Oups, quelque chose s'est mal passé",
  youAreNotAuthorized: "Vous n'êtes pas autorisé à accéder à cette page",
  youDonTHavePermissionToAccessThisPage:
    "Vous n'avez pas la permission d'accéder à cette page",
  permissionDeniedPageDescription:
    "Votre compte ne dispose pas des droits nécessaires. Contactez votre administrateur si vous avez besoin d’un accès.",
  welcomeTo: "Bienvenue à",
  pleaseSignIn:
    "Veuillez vous connecter à votre compte et commencer l'aventure",
  password: "Mot de passe",
  rememberMe: "Se souvenir de moi",
  loginHeroTitle: "Espace Collaborateur",
  loginHeroSubtitle:
    "Accédez à vos outils de gestion de conformité, KYC et dossiers clients en toute sécurité.",
  loginSecurityNote: "Plateforme sécurisée et auditée",
  loginFormSecurityNote: "Connexion sécurisée et chiffrée",
  loginHelperText: "Saisissez vos identifiants professionnels pour continuer.",
  loginEmailPlaceholder: "ex : agnese@bni.ci",
  credentials: "Informations d'identification",
  badCredentials: "Authentification échouée.",
  emailOrPasswordInvalid: "Email ou mot de passe invalide",
  forgotPassword: "Mot de passe oublié",
  login: "Se connecter",
  firstLoginResetTitle: "Première connexion",
  firstLoginResetSubtitle:
    "Pour des raisons de sécurité, vous devez définir un nouveau mot de passe avant de continuer.",
  currentPassword: "Mot de passe actuel",
  newPasswordChoice: "Nouveau mot de passe",
  confirmNewPassword: "Confirmer le nouveau mot de passe",
  passwordsDoNotMatch: "Les mots de passe ne correspondent pas",
  passwordResetSuccess: "Mot de passe réinitialisé avec succès.",
  passwordResetSuccessReconnectHint:
    "Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.",
  changePassword: "Enregistrer le nouveau mot de passe",
  passwordStrengthWeak: "Faible",
  passwordStrengthFair: "Moyenne",
  passwordStrengthGood: "Bonne",
  passwordStrengthStrong: "Forte",
  passwordStrengthHint: "Niveau de sécurité du mot de passe",
  passwordRequirementMinLength: "Au moins 8 caractères",
  passwordRequirementUppercase: "Au moins une majuscule",
  passwordRequirementLowercase: "Au moins une minuscule",
  passwordRequirementDigit: "Au moins un chiffre",
  passwordRequirementSpecial: "Au moins un caractère spécial",
  passwordConfirmMatches: "Les mots de passe sont identiques",
  passwordMustDifferFromCurrent:
    "Le nouveau mot de passe doit être différent de l’actuel",
  inputLogin: "Identifiant",
  newOnOurPlatform: "Nouveau sur notre plateforme",
  createAnAccount: "Créer un compte",
  or: "ou",
  errorOccurred: "Une erreur s'est produite",
  unexpectedOrNetworkError: "Erreur inattendue ou réseau",
  unauthorizedAction: "Action non autorisée",
  subscriptionRequired: "Abonnement requis",
  resourceNotFound: "Ressource non trouvée",
  invalidInfos: "Informations invalides",
  conflictEncountered: "Conflit rencontré",
  unavailableServer: "Serveur non disponible",
  logoutFailed: "Échec de la déconnexion",
  logout: "Déconnexion",
  sessionExpired: "Session expirée",
  sessionExpiredMessage:
    "Votre session a expiré. Veuillez vous reconnecter pour continuer.",
  externalResourceUnavailable:
    "Le service est temporairement indisponible. Veuillez réessayer plus tard.",
  unexpectedError:
    "Erreur inattendue, veuillez réessayer ou réessayer plus tard.",
  requiredField: "Ce champ est requis",
  invalidEmail: "Email invalide",
  invalidPassword: "Mot de passe invalide",
  failed: "Échoué",
  userAvatar: "Avatar de l'utilisateur",
  operationFailed: "Opération échouée",
  clientDataNotAvailable: "Données client non disponibles.",
  FailedToLogoutUser: "Échec de la déconnexion de l'utilisateur",
  tryAgain: "Réessayer",
  activities: "Activités",
  customers: "Clients",
  prospects: "Prospects",
  pipeline: "Pipeline",
  possibleMatch: "Possible match",
  duplicates: "Doublons",
  individuals: "Particuliers",
  professionals: "Professionnels",
  products: "Produits",
  inquirie_create_client: "Créer un client",
  inquiries: "Demandes",
  inquirie: "Demande",
  folders: "Dossiers",
  marketing: "Marketing",
  atm: "Agences & ATM",
  period: "Période",
  day: "Jour",
  week: "Semaine",
  month: "Mois",
  trimester: "Trimestre",
  semester: "Semestre",
  year: "Année",
  compareToPreviousDay: "comparé à hier",
  compareToPreviousWeek: "comparé à la semaine dernière",
  compareToPreviousMonth: "comparé au mois dernier",
  compareToPreviousTrimester: "comparé au trimestre dernier",
  compareToPreviousSemester: "comparé au semestre dernier",
  compareToPreviousYear: "comparé à l'année dernière",
  client: "Client",
  client360: "Clients 360",
  client360SearchFilters: "Affiner la recherche client",
  client360SearchFiltersHint:
    "Combinez les critères pour filtrer la liste des clients.",
  client360SearchSection: "Rechercher un client",
  client360ShowFilters: "Afficher la recherche",
  client360HideFilters: "Masquer la recherche",
  agency: "Agence",
  advisorName: "Conseiller",
  since: "Depuis",
  profile: "Profil",
  totalBalance: "Solde total",
  columns: "Colonnes",
  noResults: "Aucun résultat.",
  selectedRows: "ligne(s) sélectionnée(s)",
  advancedFilters: "Filtres avancés",
  kpi: "KPI",
  clear: "Effacer",
  call: "Appel",
  activity: "Activité",
  accountsProducts: "Comptes & Produits",
  transactions: "Transactions",
  analyse: "Analyse risque",
  informations: "Informations",
  notesInteractions: "Notes & Interactions",
  networkError:
    "Problème de connexion. Vérifiez votre connexion internet et réessayez.",
  customersPerPage: "Clients par page",
  loading: "Chargement",
  signature: "Signature",
  clientSince: "Client depuis",
  placeOfBirth: "Lieu de naissance",
  documentNumber: "Numéro de document",
  dateOfIssue: "Date d'émission",
  countryOfIssue: "Pays d'émission",
  placeOfDelivery: "Lieu de délivrance",
  documentReference: "Réf. doc",
  identityDocumentType: "Type de pièce d'identité",
  identityDocumentNumber: "Numéro de pièce d'identité",
  nationalIdNumber: "Numéro National de l'Identité (NNI)",
  expiryDate: "Date d'expiration",
  validatedPart: "Pièce validé",
  completionLevel: "Niveau de complétion",

  // RBAC Matrix - Additional keys
  matrixRBAC: "Matrice RBAC",
  rbacMatrixSearchSection: "Rechercher un rôle",
  rbacMatrixSearchHint: "Nom ou libellé du rôle",
  rbacMatrixFilters: "Affiner la matrice",
  rbacMatrixFiltersHint:
    "Filtrez par statut, criticité, cadence de revue et conformité SoD.",
  rolesAndAttributions: "Rôles & Attributions",
  medium: "Moyen",
  dependencies: "Dépendances",
  nbPermissions: "Nbre permissions",
  rulesManagement: "Règles",
  newRule: "Nouvelle règle",
  ruleName: "Nom de la règle",
  ruleDescription: "Description",
  noRulesFound: "Aucune règle trouvée",
  invalidPhoneFormat: "Format de téléphone invalide",

  // User
  user: "Utilisateur",
  state: "État",
  presence: "Présence",
  backup: "Backup",
  permissions: "Permissions",

  // Documents
  category: "Catégorie",
  date: "Date",
  send: "Envoyer",
  download: "Télécharger",
  documentDownloaded: "Document téléchargé",
  documentDownloadError: "Erreur lors du téléchargement du document",
  documentPreviewTitle: "Aperçu du document",
  documentPreviewError: "Impossible de charger l'aperçu du document",
  documentPreviewNotSupported: "Aperçu non disponible pour ce type de fichier",
  screeningReportDownloaded: "Rapport de screening téléchargé",
  screeningReportDownloadError:
    "Erreur lors du téléchargement du rapport de screening",
  documentPerPage: "Documents par page",
  // Demandes - Sélection manuelle UI
  filters: "Filtres",
  channel: "Canal",
  country: "Pays",
  segment: "Segment",
  availableRequests: "What disponibles",
  continue: "Continuer",
  requiredFields: "Champs requis",
  missingFields: "Champs manquants",
  // Request items
  request_create_account: "Ouverture de compte",
  request_create_account_desc: "Démarrer une ouverture de compte bancaire.",
  request_onboarding_a2: "Démarrer Onboarding (A2)",
  request_onboarding_a2_desc:
    "Ouvrir un dossier d’onboarding A2 pour un client/prospect.",
  request_regen_otp: "Régénérer accès (OTP)",
  request_regen_otp_desc:
    "Envoyer des instructions OTP pour réinitialisation mot de passe / reconnexion.",
  request_secure_upload_reminder: "Relance upload sécurisé",
  request_secure_upload_reminder_desc:
    "Envoyer une relance avec lien sécurisé pour dépôt de pièces.",
  request_id_replacement: "Remplacement de pièce d’identité",
  request_id_replacement_desc:
    "Remplacer une pièce d’identité expirée ou invalide.",
  request_address_change: "Changement d’adresse",
  request_address_change_desc:
    "Mettre à jour l’adresse et justificatifs associés.",
  request_four_eyes: "4‑yeux documentaire",
  request_four_eyes_desc:
    "Déclencher un contrôle à 4‑yeux sur un dossier documentaire.",
  request_rekcy: "Déclencher Re‑KYC",
  request_rekcy_desc:
    "Ouvrir une demande Re‑KYC selon la politique en vigueur.",
  request_export_kpi: "Exporter KPI conformité",
  request_export_kpi_desc:
    "Demande d’export KPIs (complétude, expirés, erreurs OCR, ré‑usage).",
  request_contact_update: "Modification coordonnées",
  request_contact_update_desc:
    "Mettre à jour les informations de contact du client.",
  request_account_closure: "Clôture de compte",
  request_account_closure_desc: "Clôturer un compte bancaire actif.",
  request_add_proxy: "Ajouter une procuration (mandataire)",
  request_add_proxy_desc:
    "Créer/ajouter une procuration pour un client (portée et limites).",
  request_pep_declaration: "Déclaration PEP",
  request_pep_declaration_desc:
    "Déclarer ou mettre à jour le statut PEP (client ou proche).",
  request_civil_status_change: "Changement d'état civil",
  request_civil_status_change_desc:
    "Déclarer un changement d'état civil avec pièces justificatives.",
  request_add_legal_representative: "Ajout représentant légal",
  request_add_legal_representative_desc:
    "Ajouter/désigner un représentant légal avec justificatifs.",
  request_income_employer_update: "Mise à jour revenu et employeur",
  request_income_employer_update_desc:
    "Mettre à jour la rémunération, l'employeur et le secteur d'activité.",
  request_family_situation_change: "Changement de situation familiale",
  request_family_situation_change_desc:
    "Mettre à jour le régime matrimonial, le conjoint et le nombre d'enfants.",
  request_create_prospect: "Créer un prospect",
  request_create_prospect_desc:
    "Saisir la création d’un prospect et déclencher le flux associé.",
  demandes: "Demandes",
  nouvelleDemande: "Nouvelle Demande",

  // Prospects
  type: "Type",
  contact: "Contact",
  accessStatus: "Statut accès",
  canal: "Canal",
  screening: "Screening",
  additionalDocuments: "Documents & Pièces supplémentaires",
  lastUpdate: "Dernière MAJ",
  createdAt: "Créé le",

  birthDate: "Date de naissance",
  notes: "Notes",
  motif: "Motif",
  address1: "Adresse 1",
  address2: "Adresse 2",
  city: "Ville",
  deliveredDate: "Date de délivrance",
  IdDocType: "Type de document",
  IdDocNumber: "Numéro de document",
  birthPlace: "Lieu de naissance",

  // Onboarding
  identification: "Identification",
  update: "Editer",
  editable: "Editable",
  readOnly: "Lecture seule",

  // client
  clients: "Clients",
  selectClient: "Sélectionner un client",
  selectClientDescription: "Recherchez un client pour ouvrir sa vue 360.",
  clientSearch: "Nom, Party ID, NCI, téléphone, email",
  sensitiveClientsFilter: "Sensibilité",
  sensitiveFilterAll: "Tous",
  sensitiveFilterWithout: "Non sensible",
  sensitiveFilterWith: "Sensible",
  kyc: "KYC",
  partyid: "Party ID",
  account: "Comptes",

  synthese: "Synthèse",
  risqueReKyc: "Risques & Re-KYC",
  scoringProfilTitle: "Profil Risque",
  scoringScore: "Score",
  scoringDeclencheurs: "Déclencheurs",
  scoringVoirDetails: "Voir détails",
  scoringPolitiqueRisque: "Politique Risque",
  scoringNotCalculated: "Profil de risque non encore calculé",
  scoringClasseDeRisque: "Classe de risque",
  scoringNonCalcule: "Non calculé",
  scoringTrackA: "Référentiel Identité",
  scoringTrackB: "Contrôle externe",
  scoringCombined: "Score combiné",
  scoringDecision: "Décision",
  scoringCompleteness: "Complétude",
  scoringScoredAt: "Scoré le",
  scoringScoredBy: "Scoré par",
  scoringTrigger: "Déclencheur",
  scoringFactorsTitle: "Facteurs",
  scoringLoadError: "Le chargement du profil de risque a échoué.",
  scoringClassification: "Classification",
  scoringRawScore: "Score brut",
  scoringWeight: "Poids",
  scoringHardOverrides: "Dérogations",
  scoringEntity: "Entité",
  scoringEntityLabel: "Libellé",
  scoringLevel: "Niveau",
  scoringPoints: "Points",
  accounts: "Comptes",
  accountSingular: "Compte",
  consents: "Consentements",
  timeline: "Timeline",
  fiche: "Fiche client",

  // Create Prospect Page
  createProspectPhysicalPersonTitle:
    "Créer un prospect — Personne physique (PP) (BCEAO)",
  requiredInformation: "Informations obligatoires",
  optionalInformation: "Informations optionnelles",
  physicalPerson: "Personne Physique",
  sex: "Sexe",
  masculine: "Masculin",
  feminine: "Féminin",
  selectOption: "Sélectionnez",
  cni: "CNI",
  passport: "PASSEPORT",
  drivingLicense: "PERMIS DE CONDUIRE",
  notesOptional: "Notes (optionnel)",
  dateFormat: "jj/mm/aaaa",
  errorCreatingProspect: "Erreur lors de la création du prospect",
  prospectCreatedSuccessfully: "Prospect créé avec succès !",
  prospectCreatedRedirectMessage:
    "Votre prospect a été créé avec succès. Vous allez être redirigé...",
  requiredFieldsDisclaimer:
    "* champs obligatoires — au moins un contact (téléphone ou email).",
  cancel: "Annuler",
  create: "Créer",
  creating: "Création...",
  idType: "Type de pièce",
  idNumber: "N° pièce",
  issueDate: "Date délivrance",
  addressLine1: "Adresse (ligne 1)",
  addressLine2: "Adresse (ligne 2)",

  // New prospect form translations
  civilite: "Civilité",
  genre: "Genre",
  masculineShort: "M",
  feminineShort: "F",
  mr: "M.",
  mrs: "Mme.",
  miss: "Mlle.",
  mobile: "Téléphone portable",
  sendOTP: "Envoyer OTP",
  OTPSent: "OTP envoyé",
  verifyOTP: "Vérifier",
  otpCode: "Code de vérification",
  productOfInterest: "Produit d'intérêt",
  productsOfInterest: "Produits d'intérêt",
  intentComment: "Motif / Commentaire",
  intentCommentPlaceholder:
    "Précisez le motif ou ajoutez un commentaire… (280 caractères max.)",
  createProspectAccountObject: "Objet du compte",
  wantsContactForProducts: "Souhaite être contacté pour épargne/carte/crédit",
  validateAndContinue: "Valider & continuer",
  startOnboarding: "Démarrer Onboarding",
  coordinatesAndIntent: "Coordonnées & Intention",
  notesAndMentions: "Notes & @mentions",
  requestContext: "Contexte de la demande",
  what: "What",
  produit: "Produit",
  notDefined: "Non défini",
  characterLimit: "280 caractères",
  chooseOption: "Choisir",
  carte: "Carte",
  epargne: "Épargne",
  compteAVueXOF: "Compte à vue XOF",
  suivant: "Suivant",

  rm: "RM",
  relationshipManager: "Chargé de relation",
  prospectCreated: "Prospect créé",
  prospectCreatedModalDescription:
    "Souhaitez-vous enchaîner avec la collecte des pièces et consentements ?",
  prospectCreatedModalDescriptionPm:
    "Retrouvez-le depuis la liste des prospects pour poursuivre son traitement.",
  clientCreated: "Client créé avec succès",
  clientCreatedModalDescription:
    "Souhaitez-vous enchaîner sur la fiche client ?",
  nextStep: "Étapes suivantes",
  verifyRequiredDocuments: "Vérifier les pièces obligatoires du dossier.",
  confirmConsents: "Confirmer les consentements KYC et marketing.",
  goToProspectList: "Revenir à la liste prospects",
  continueOnboarding: "Continuer l’ouverture de compte",
  accessToClientProfile: "Accéder à la fiche client",
  continueClientProfile: "Continuer sur la fiche du client",
  generateClientAccess: "Générer un accès client",
  pepOnboardingSubmittedTitle: "Soumission réussie",
  pepOnboardingSubmittedDescription:
    "Le dossier a été enregistré et transmis pour traitement.",
  pepOnboardingComplianceFourEyesMessage:
    "Il a été envoyé en validation 4-yeux au service Conformité.",
  pepOnboardingAccountCreationPendingMessage:
    "Le compte client ne pourra être créé qu'après validation par le service Conformité.",
  createNewProspect: "Créer un nouveau prospect",
  onboardingGate_loading: "Vérification du screening en cours…",
  onboardingGate_error:
    "Impossible de récupérer le verdict du screening. Veuillez réessayer.",
  onboardingGate_unavailable:
    "Verdict de screening indisponible. Veuillez réessayer.",
  onboardingGate_pass_banner:
    "Screening conforme — la création du client est autorisée.",
  onboardingGate_outcome_created: "Le client a été créé avec succès.",
  onboardingGate_sanctions:
    "Création refusée : correspondance sanctions. Le service Conformité est notifié.",
  onboardingGate_pep:
    "Client PEP : le dossier est transmis au service Conformité pour revue 4-yeux. La Conformité prend le relais.",
  onboardingGate_screeningInProgress:
    "Screening en cours… Le verdict sera disponible dans un instant.",
  onboardingGate_softPass:
    "Le dossier sera transmis au service Conformité pour revue.",
  onboardingGate_outcome_createdRouted:
    "Le client a été créé. Le dossier sera transmis au service Conformité pour revue.",
  onboardingGate_routedReview:
    "Le dossier sera transmis au service Conformité pour revue.",
  onboardingGate_refresh: "Actualiser",
  onboardingGate_routed_title: "Dossier transmis à la Conformité",
  onboardingGate_sanctions_title: "Création refusée",

  onlyLetters: "Ce champ ne doit contenir que des lettres, espaces ou tirets",
  identityInformation: "Informations d'identité",
  companyIdentityInformation: "Identité entreprise",
  declarantContact: "Contact déclarant",
  companyName: "Raison sociale",
  registrationNumberOptional: "N° RCCM",
  contactPersonName: "Nom du contact",
  declarantRole: "Rôle du déclarant",
  pmOnboardingUnavailableTitle: "Fonctionnalité pas encore disponible",
  pmOnboardingUnavailableDescription:
    "L'onboarding en ligne des personnes morales est en cours de construction. Cette fonctionnalité sera disponible prochainement pour cette catégorie de prospects.",
  understood: "Compris",

  onboarding: "Onboarding",
  productIntent: "Intention / Intérêt produit",
  backgroundToRequest: "Contexte de la demande",
  infosIntent: "Coordonnées & Intention",
  addressProfile: "Coordonnées (adresse & profil)",
  salaryAmount: "Salaire (montant)",
  activitySector: "Secteur d'activité",
  stepEntreprise: "Entreprise",
  legalIdentificationKyb: "Identification légale (KYB)",
  addressAndContact: "Adresse & coordonnées",
  tradeName: "Nom commercial",
  companyPhone: "Téléphone entreprise",
  companyEmail: "Email entreprise",
  legalForm: "Forme juridique",
  registrationNumber: "N° RCCM",
  taxId: "Identifiant fiscal (NIF)",
  incorporationCountry: "Pays d'incorporation",
  incorporationDate: "Date de constitution",
  shareCapital: "Capital social (FCFA)",
  headOfficeAddress: "Adresse du siège social",
  corporateObject: "Objet social",
  legalFormSarl: "SARL",
  legalFormSa: "SA",
  legalFormSas: "SAS",
  legalFormGie: "GIE",
  legalFormHolding: "Holding",
  legalFormAssociation: "Association / ONG",
  legalFormPublicEntity: "Entité Publique",
  sectorCommerce: "Commerce général",
  sectorAgriculture: "Agriculture",
  sectorConstruction: "BTP / Construction",
  sectorRealEstate: "Immobilier",
  sectorForeignExchange: "Change manuel",
  sectorGambling: "Jeux d'argent",
  sectorFinancialServices: "Services financiers",
  sectorTransport: "Transport / Logistique",
  saveSuccessful: "Enregistré avec succès",
  saveFailed: "Échec de l'enregistrement",
  stepRepresentants: "Représentants",
  addRepresentative: "Ajouter un représentant / mandataire",
  removeRepresentative: "Retirer",
  activeSignatoryBlocksRemoval:
    "Cette personne est signataire actif d'un mandat en cours. Révoquez le mandat avant de la retirer.",
  alreadyKnownInSystem: "Déjà connu(e) dans le SI",
  representativesListTitle: "Représentants et mandataires",
  showDetails: "Détails",
  hideDetails: "Masquer",
  addedOn: "Ajouté le",
  identitySource: "Origine",
  sourceAgentInput: "Saisi manuellement",
  sourceRicProjection: "Projeté depuis le RIC",
  rolesHeld: "Rôles",
  addRole: "Ajouter un rôle",
  removeRole: "Retirer",
  lastRoleCannotBeRemoved: "Dernier rôle : non retirable",
  noRoleToAdd: "Tous les rôles disponibles sont déjà attribués",
  searchExistingPerson: "Rechercher une personne existante",
  searchPersonPlaceholder: "Nom du représentant...",
  noResultsFound: "Aucun résultat",
  manualEntry: "Saisie manuelle",
  chooseRole: "Choisir un rôle",
  possibleMatchesFound:
    "Un profil correspondant existe déjà — réutilisez-le ou confirmez qu'il s'agit d'une autre personne.",
  matchTypeExact: "Correspondance exacte",
  matchTypePartial: "Correspondance partielle — vérifiez avant de fusionner",
  reuseThisPerson: "Réutiliser cette personne",
  confirmDifferentPerson: "Il s'agit d'une autre personne",
  representativeAddedSuccess: "Représentant ajouté au dossier",
  removalNotSupportedYet:
    "Le retrait d'un représentant n'est pas encore possible : attribuez-lui plutôt un autre rôle si besoin.",
  alreadyLinkedRoles: "Rôles déjà tenus",
  functionGerant: "Gérant",
  functionDG: "Directeur Général",
  functionPDG: "Président-Directeur Général",
  functionPresident: "Président",
  functionAdministrateur: "Administrateur",
  residenceCountry: "Pays de résidence",
  identityDocumentSectionTitle: "Pièce d'identité",
  runOcr: "Lancer l'OCR",
  uploadDocumentToContinue:
    "Téléversez la pièce d'identité et lancez l'OCR pour continuer.",
  representativeDocumentType: "Type de pièce",
  documentTypeCNI: "CNI",
  documentTypePassport: "Passeport",
  documentTypeResidencePermit: "Titre de séjour",
  mandateSectionTitle: "Mandat & pouvoirs",
  mandateReference: "Référence du mandat",
  mandateType: "Type de mandat",
  mandateStartDate: "Date de début",
  mandateEndDate: "Date de fin",
  mandateCertifiedDocument: "Document certifié",
  mandateTypeStatutory: "Représentant légal statutaire",
  mandateTypeProxy: "Procuration",
  mandateTypeDelegation: "Délégation",
  mandateTypeBankMandate: "Mandat bancaire",
  mandatesSectionTitle: "Mandataires",
  addMandate: "Ajout de mandataire",
  mandateRole: "Rôle du mandataire",
  mandateRolePrincipal: "Principal",
  mandateRoleSimple: "Simple",
  mandateReason: "Motif / justification",
  mandateSaved: "Mandataire enregistré avec succès",
  mandateSaveFailed: "Échec de l'enregistrement du mandataire",
  mandateRemoved: "Mandataire retiré avec succès",
  mandateRemoveFailed: "Échec du retrait du mandataire",
  mandateRemoveConfirmTitle: "Retirer le mandataire",
  mandateRemoveConfirmDescription:
    "Fournissez un motif de retrait. Ce motif sera conservé dans l'historique du mandat.",
  mandateRemoveReasonLabel: "Motif de retrait",
  mandateRemoveReasonPlaceholder:
    "Décrivez pourquoi le mandataire est retiré… (500 caractères max.)",
  mandateRemoveReasonRequired:
    "Un motif est requis pour retirer le mandataire.",
  mandatePrincipalAlreadyExists:
    "Un mandataire principal actif existe déjà. Seuls des mandataires simples peuvent être ajoutés.",
  mandateListEmpty: "Aucun mandataire enregistré",
  stepActionnariat: "Actionnariat & UBO",
  significantShareholdersQuestion:
    "Y a-t-il des actionnaires détenant ≥ 25% du capital ou des droits de vote ?",
  addShareholder: "Ajouter un actionnaire",
  removeShareholder: "Retirer l'actionnaire",
  personTypePP: "Personne physique",
  personTypePM: "Personne morale",
  percentageHeldLabel: "% détenu",
  shareholderLegalName: "Raison sociale",
  shareholderRegistryNumber: "N° RCCM",
  uboEffectifLabel: "UBO effectif",
  belowUboThresholdLabel: "Sous le seuil 25%",
  shareholdingSumError:
    "La somme des pourcentages des actionnaires directs doit égaler 100%.",
  completeRequiredFieldsMessage: "Veuillez compléter les champs obligatoires.",
  controlGraphTitle: "Graphe de contrôle",
  exportGraph: "Exporter",
  exportComingSoon: "À venir",
  shareholderIdentificationDate: "Date identification",
  shareholderLastVerificationDate: "Dernière vérification",
  shareholderProofSource: "Source preuve",
  legendPpIdentified: "PP identifié",
  legendPmIntermediary: "PM intermédiaire",
  legendBelowThreshold: "Sous le seuil",

  stepDocuments: "Documents",
  documentChecklistTitle: "Documents requis",
  documentChecklistDescription:
    "Cette checklist est générée selon la forme juridique et le pays de l'entreprise.",
  documentChecklistLoading: "Génération de la checklist documentaire…",
  documentChecklistEmpty: "Aucune checklist documentaire pour le moment.",
  documentProvided: "Fourni",
  documentRequiredBadge: "Requis",
  documentChecklistIncompleteMessage:
    "Tous les documents requis doivent être marqués comme fournis avant de continuer.",
  documentIndeterminateBadge: "Indéterminé",
  documentChecklistIndeterminateMessage:
    "Les exigences documentaires n'ont pas pu être déterminées — vérifiez auprès de la conformité avant de continuer.",
  documentStatusAttendue: "Attendue",
  documentStatusRecue: "Reçue, en attente de contrôle",
  documentStatusValide: "Validée",
  documentStatusExpiree: "Expirée, à renouveler",
  documentOptionalBadge: "Optionnel",
  documentUploadButton: "Déposer la pièce",
  documentReplaceButton: "Remplacer la pièce",
  documentUploadUnavailable: "Dépôt en ligne pas encore disponible",
  documentUploadInProgress: "Dépôt en cours…",
  documentUploadError: "Le dépôt a échoué, réessayez.",
  documentTypeStatuts: "Statuts constitutifs",
  documentTypeRccm: "Extrait RCCM",
  documentTypePieceIdentiteRl: "Pièce d'identité du représentant légal",
  documentTypeNominationDirigeants: "Acte de nomination des dirigeants",
  documentTypeDeclarationBeneficiairesEffectifs:
    "Déclaration des bénéficiaires effectifs",
  documentTypeConventionGie: "Convention constitutive du GIE",
  documentTypeRecepisseDeclaration: "Récépissé de déclaration",

  stepScreening: "Screening",
  pmScreeningTitle: "Screening sanctions / PEP / adverse media",
  pmScreeningDescription:
    "Le screening est exécuté en amont (RIC / VNeuron) sur l'entreprise, ses actionnaires et ses représentants — cet écran ne fait que projeter le résultat.",
  pmScreeningRunning: "Projection des résultats de screening…",
  pmScreeningEntityTypeEntreprise: "Entreprise",
  pmScreeningEntityTypeActionnaire: "Actionnaire",
  pmScreeningEntityTypeRepresentant: "Représentant",
  pmScreeningListSourceSanctions: "Sanctions",
  pmScreeningListSourcePep: "PEP",
  pmScreeningListSourceAdverseMedia: "Adverse media",
  pmScreeningQualificationTruePositive: "Vrai positif",
  pmScreeningQualificationFalsePositive: "Faux positif",
  pmScreeningQualificationUncertain: "Incertain (escaladé)",
  pmScreeningFalsePositivePendingValidation:
    "Faux positif — en attente de validation",
  pmScreeningStatusPending: "En attente",
  pmScreeningStatusClear: "Clear",
  pmScreeningStatusHit: "Hit",
  pmScreeningStatusInconclusive: "Non concluant",

  stepRiskScore: "Score de risque",
  riskScoreTitle: "Score de risque composite BCEAO",
  riskScoreDescription:
    "Calculé à partir du secteur d'activité de l'entreprise, de ses représentants et des résultats du screening.",
  riskScoreLoading: "Calcul du score de risque…",
  riskScoreCompositeLabel: "Score composite",
  riskScoreLevelLabel: "Niveau de risque",
  riskScoreFactorsTitle: "Facteurs de risque",
  riskScoreVigilanceMessage:
    "Une vigilance renforcée est requise pour ce dossier.",
  riskLevelLow: "Low",
  riskLevelStandard: "Standard",
  riskLevelHigh: "High",
  riskLevelCritical: "Critical",
  riskFactorBase: "Score de base composite",
  riskFactorHoldingStructure: "Structure Holding / complexité",
  riskFactorIntermediatePM: "PM intermédiaire dans la chaîne",
  riskFactorForeignUbo: "UBO étranger",
  riskFactorSensitiveSector: "Secteur d'activité sensible",
  riskFactorPepRepresentative: "PEP (RL ou BE)",
  riskFactorDigitalChannel: "Canal digital",
  riskFactorGafiNonCooperativeCountry: "Pays GAFI non-coopératif",
  riskFactorYoungCompany: "Entreprise < 2 ans",

  decisionOutcomeApprovedComplete: "Dossier complet / Approuver",
  decisionOutcomeApprovedWithRestrictions: "Approuver avec restrictions",
  decisionOutcomeRejected: "Rejeté",
  decisionOutcomeRegulatoryHold: "Mise en attente réglementaire",

  stepAccountOpening: "Ouverture de compte",
  accountOpeningTitle: "Récapitulatif final & ouverture de compte",
  accountOpeningRecapCompanyName: "Entreprise",
  accountOpeningRecapLegalForm: "Forme juridique",
  accountOpeningRecapShareholders: "Actionnaires",
  accountOpeningRecapScreening: "Screening",
  accountOpeningRecapScoreDecision: "Score · Décision",
  accountOpeningRecapSignatoriesTitle: "Signataires à enregistrer",
  accountOpeningBlockedMessage:
    "Le compte ne peut être créé que lorsque le dossier a été approuvé.",
  accountOpeningCreateButton: "Créer le compte",
  accountOpeningConfirmTitle: "Créer le compte ?",
  accountOpeningConfirmDescription:
    "Cette action est irréversible : le compte et ses signataires seront créés dans Orion.",
  accountOpeningConfirmAction: "Confirmer la création",
  accountOpeningSuccessMessage: "Compte créé avec succès.",
  accountOpeningAccountNumberLabel: "Numéro de compte",
  accountOpeningSignatoriesLabel: "Signataires",

  stepEvidencePack: "Evidence pack",
  evidencePackTitle: "Evidence pack",
  evidencePackDescription:
    "Récapitulatif exportable du dossier, conforme à l'instruction applicable, avec la date de la prochaine revue périodique.",
  evidencePackGenerateButton: "Générer & exporter l'evidence pack",
  evidencePackLoading: "Génération de l'evidence pack…",
  evidencePackComplianceStatement:
    "Cet evidence pack est conforme à l'Instruction BCEAO n°003-03-2025.",
  evidencePackReferenceLabel: "Référence",
  evidencePackGeneratedAtLabel: "Généré le",
  evidencePackNextReviewDateLabel: "Prochaine revue périodique",
  evidencePackDownloadButton: "Télécharger (PDF)",
  evidencePackRegenerateButton: "Régénérer",
  evidencePackContinueButton: "Ouverture du compte",
  evidencePackHashLabel: "Hash",
  evidencePackSectionIdentification: "Identification client",
  evidencePackSectionRegistration: "Immatriculation & Fiscalité",
  evidencePackSectionRepresentation: "Représentant légal & Mandats",
  evidencePackSectionShareholding: "Actionnariat & UBO",
  evidencePackSectionDocuments: "Documents reçus",
  evidencePackSectionScreening: "Résultats screening",
  evidencePackSectionRiskScore: "Score de risque",
  evidencePackSectionDecision: "Décision KYB",
  evidencePackSectionRestrictions: "Restrictions éventuelles",
  evidencePackSectionAuditTrail: "Audit trail",
  evidencePackSectionStatusVerified: "Vérifié",
  evidencePackSectionStatusComplete: "Complet",
  evidencePackSectionStatusPartial: "Partiel",
  evidencePackSectionStatusMissing: "Manquant",
  evidencePackDetailVerified: "Vérifié",
  evidencePackDetailNotVerified: "Non vérifié",
  evidencePackDetailMissing: "Manquant",
  evidencePackDetailComplete: "Complet",
  evidencePackDetailPartial: "Partiel",
  evidencePackDetailHitConfirmed: "Hit confirmé",
  evidencePackDetailNone: "Aucune",
  evidencePackDetailRestrictionsApplied: "Restrictions appliquées",
  evidencePackDetailAwaitingDecision: "En attente de décision",

  request: "Demande",
  partsApproval: "Pièces & Consentements",
  metadataOcr: "Métadonnées & OCR",
  summaryValidation: "Résumé & validation",
  reviewSummaryTitle: "Récapitulatif — Validation avant création client",
  verifyBeforeCreate:
    "Vérifiez l'ensemble des informations avant de confirmer la création",
  screeningAndProfile: "Screening & Profil",
  screeningRule: "Règle",
  screeningDetail: "Détail",
  noScreeningRules: "Aucune règle de contrôle",
  screeningRulesPending: "Contrôles en cours, les résultats arrivent...",
  screeningRulesUnavailable: "Les contrôles sont indisponibles pour le moment. Réessayez dans quelques instants ou signalez-le au support.",
  screeningProvider: "Source",
  screeningAdvisoryNotice: "Le contrôle externe VNeurone est consultatif : son verdict est enregistré et transmis à la conformité, mais il ne bloque pas l'entrée en relation. La décision finale est notifiée séparément.",
  screeningExternalNotStarted: "Le contrôle d'éligibilité externe n'a pas encore répondu. Il est lancé en parallèle et son résultat s'affichera ici : ce n'est pas une anomalie.",
  screeningExternalPending: "Le contrôle d'éligibilité externe a ouvert une revue chez le partenaire bancaire. Un analyste y lève les correspondances homonymes ; sa décision nous sera notifiée. L'entrée en relation n'est pas bloquée pendant ce temps.",
  riskFactorsTitle: "Facteurs de risque",
  riskFactorsDecisive: "Facteurs déterminants",
  riskFactorsOthers: "Autres facteurs évalués",
  riskFactorsScore: "Score",
  riskFactorsCompleteness: "Complétude du dossier",
  riskFactorsHardOverride: "Règle de surclassement appliquée",
  riskFactorsUnavailable:
    "Le détail des facteurs de risque n'est pas disponible pour ce dossier.",
  riskFactorNotApplicable: "Non évalué",
  riskFactorUnknownCode: "Code inconnu",
  riskFactorNoValue: "Aucune valeur renseignée",
  riskFactorsColEntity: "Entité",
  riskFactorsColValue: "Valeur retenue",
  riskFactorsColLevel: "Niveau",
  riskFactorsColPoints: "Points",
  riskFactorsAssessedEntities: "entités évaluées",

  // Screening step & OCR
  ocrExtractionTitle: "Extraction OCR",
  ocrExtractionDescription:
    "Les champs issus de l’OCR peuvent être vérifiés et corrigés avant enregistrement.",
  ocrStatusInProgress: "EN COURS",
  ocrStatusFailed: "ÉCHEC",
  ocrStatusReady: "PRÊT",
  screeningInvalidIdTitle: "Pièce d'identité invalide",
  screeningInvalidIdDescription:
    "Vous ne pouvez pas continuer avec une pièce d'identité invalide. Veuillez téléverser un nouveau document valide.",
  screeningInvalidIdInline:
    "Vous ne pouvez pas continuer tant que la pièce d'identité est invalide.",
  ocrApplyButton: "Valider et enregistrer",
  ocrApplyButtonLoading: "En cours...",

  // Result Screening
  SANCTIONS_PEP: "Sanctions PEP",
  ELIGIBILITE_EXTERNE: "Contrôle éligibilité externe",
  screeningStatus_clean_label: "CLEAN",
  screeningStatus_pending_label: "EN ATTENTE",
  screeningStatus_reject_label: "REFUS",
  COMPLETUDE: "Complétude",
  OCR_QUALITE: "Qualité OCR",
  COHERENCE_IDENTITE: "Coherence identité",
  RISQUE_INITIAL: "Risque initial",

  productsAccounts: "Produits & Comptes",
  productsAccountsDescription:
    "Sélectionnez le type de client, le produit et les services demandés.",
  screeningContext: "Contexte de screening",
  majorMinor: "Majeur/Mineur",
  resident: "Résident",
  nonResident: "Non-résident",
  pepStatus: "Statut PEP",
  clientType: "Type de client",
  product: "Produit",
  productCategory: "Catégorie de produit",
  additionalServices: "Services supplémentaires",
  classicCreditCard: "Carte de crédit classique",
  classicCreditCardDescription: "Carte de débit classique",
  smsBanking: "SMS Banking",
  smsBankingDescription: "Alertes et opérations par SMS",
  internetBanking: "Internet Banking",
  internetBankingDescription: "Accès web aux opérations",
  checkbook: "Chéquier",
  checkbookDescription: "Carnet de chèques nominatif",

  // Screening status pills (labels)
  screeningStatus_ok_label: "OK",
  screeningStatus_avert_label: "AVERT.",
  screeningStatus_alerte_label: "ALERTE",
  screeningStatus_echec_label: "ECHEC",
  screeningStatus_clear_label: "CLEAR",
  screeningStatus_faible_label: "FAIBLE",
  screeningStatus_standard_label: "STANDARD",
  screeningStatus_high_label: "ÉLEVÉ",
  screeningStatus_unknown_label: "INCONNU",
  screeningStatus_unknown_tooltip: "Statut de screening non reconnu.",

  // Screening status pills (tooltips by rule)
  screeningStatus_risqueInitial_ok: "Aucun risque détecté.",
  screeningStatus_risqueInitial_avert:
    "Risque modéré (pièce invalide, documents manquants…).",
  screeningStatus_risqueInitial_alerte: "Risque élevé, revue manuelle requise.",

  screeningStatus_coherenceIdentite_ok: "Données concordantes.",
  screeningStatus_coherenceIdentite_avert:
    "Match partiel (par exemple prénoms seulement).",
  screeningStatus_coherenceIdentite_echec:
    "Incohérence identité ou pièce non valide.",

  screeningStatus_ocrQualite_ok:
    "Qualité vérifiée, données OCR extraites correctement.",
  screeningStatus_ocrQualite_echec:
    "Données OCR manquantes ou illisibles, contrôle manuel requis.",

  screeningStatus_completude_ok:
    "Tous les documents KYC requis ont été fournis.",

  screeningStatus_sanctionsPep_clear: "Aucun match sanctions / PEP détecté.",
  screeningStatus_sanctionsPep_faible:
    "Matchs de faible pertinence, à surveiller.",
  screeningStatus_sanctionsPep_standard:
    "Matchs pertinents, une revue détaillée est requise.",
  screeningStatus_sanctionsPep_high:
    "Matchs de haute pertinence, risque élevé de sanctions / PEP.",

  // Additional Documents Step (Onboarding)
  additionalDocumentsStepTitle: "Documents supplémentaires",
  requiredShort: "Obligatoires",
  optionalShort: "Optionnels",
  validatedShort: "Validés",
  pendingShort: "En attente",
  idDocumentName: "Pièce d'identité",
  proofOfResidenceUnder3Months: "Justificatif de domicile < 3 mois",
  signedOpeningForm: "Formulaire d'ouverture signé",
  pepDeclaration: "Déclaration PEP",
  savingsObjectiveCertificate: "Attestation objectif épargne",

  // OCR sections
  ocrAddressContactTitle: "Adresse & contact",
  ocrIdentityTitle: "Identité du client",
  ocrDocumentDetailsTitle: "Détails du document",
  ocrDocumentDetailsDescription:
    "Informations extraites du document d'identité. Vérifiez et corrigez si nécessaire.",
  ocrFamilyTitle: "Situation familiale",
  ocrProfessionalTitle: "Situation professionnelle",
  ocrAdditionalFieldsTitle: "Champs complémentaires",
  placeholderPaysProfessionExample: "Ex: CI",

  // OCR placeholders/examples
  placeholderCityExample: "ex: Paris",
  placeholderPostalCodeExample: "ex: 75001",
  placeholderPlaceOfBirthExample: "ex: Paris",
  placeholderDocumentNumberExample: "Ex: CI1234567890",
  placeholderCountryExample: "ex: Côte d'Ivoire",
  placeholderNumberOfChildrenExample: "ex: 2",
  placeholderProfessionExample: "Ex: Chef d'entreprise",
  placeholderActivitySectorExample: "ex: Agriculture",
  placeholderSalaryExample: "ex: 450 000",

  // Core Banking Search
  coreBanking: "Core banking",
  searchCoreBanking: "Rechercher un client dans le core banking",
  searchCoreBankingDescription:
    "Saisissez un numéro de compte pour interroger le core banking. Les résultats apparaîtront dans la liste.",
  accountNumber: "Numéro de compte",
  searchCoreBankingTip:
    "Astuce : vous pouvez fermer cette boîte de dialogue, les résultats core banking restent visibles dans la liste.",

  // Empty State Messages
  noCustomersFound: "Aucun client ne correspond à votre recherche.",
  tryAdjustingFilters:
    "Essayez d'ajuster vos filtres pour obtenir plus de résultats.",
  startSearching: "Commencez par rechercher ou ajuster les filtres ci-dessus.",

  access_generated_successfully: "Accès généré avec succès",
  access_generated_successfully_description:
    "L'accès a été généré avec succès. Vous pouvez maintenant vous connecter.",
  access_generated_failed: "Échec de la génération de l'accès",
  access_generated_failed_description:
    "Une erreur s'est produite lors de la génération.",
  access_generating: "Génération en cours...",
  access_generating_description:
    "La génération de l'accès est en cours. Veuillez patienter.",
  regenerate_access: "Régénérer accès",
  generate_access: "Générer accès",
  revoke_access: "Révoquer accès",
  revoke_confirm_title: "Confirmer la révocation d'accès",
  revoke_confirm_description:
    "Cette action révoque immédiatement l'accès du prospect. Le motif est obligatoire.",
  revoke_sensitive_warning:
    "Action sensible : l'accès sera désactivé immédiatement.",
  revoke_reason_label: "Motif",
  revoke_reason_placeholder: "Sélectionner un motif",
  revoke_reason_suspicion_fraud: "Suspicion de fraude",
  revoke_reason_creation_error: "Erreur de création",
  revoke_reason_end_relationship: "Fin de relation prospect",
  revoke_reason_customer_request: "Demande du prospect",
  revoke_reason_internal_control: "Contrôle interne",
  revoke_reason_other: "Autre",
  revoke_reason_custom_placeholder: "Précisez le motif (minimum 10 caractères)",
  revoke_reason_min_counter: "{{count}}/10 caractères minimum",
  revoke_confirm_button: "Confirmer la révocation",
  revoke_confirming_button: "Révocation...",
  access_revoking: "Révocation de l'accès en cours...",
  access_revoking_description:
    "Veuillez patienter pendant la révocation des credentials.",
  access_revoked_successfully: "Accès révoqué",
  access_revoked_successfully_description:
    "L'accès du prospect a été révoqué avec succès.",
  access_revoke_failed: "Échec de la révocation d'accès",
  access_revoke_failed_description:
    "La révocation a échoué. Veuillez réessayer.",
  access_revoked_alert_title: "Accès révoqué",
  access_revoked_alert_description:
    "L'accès a été révoqué. Les accès de ce prospect sont coupés.",

  missing: "Manquant",
  uploaded: "Téléchargé",
  verified: "Vérifié",
  required: "Obligatoire",
  optional: "Optionnel",
  clickToUpload: "Glisser-déposer ou cliquez pour ajouter",
  notdocumentToUpload: "Aucun document à télécharger",
  notdocumentToUploadDescription:
    "Il n'y a aucun document à télécharger, vous pouvez soumettre l'oanboarding.",

  // KYC
  civilIdentity: "Identité civile",
  actionRequired: "Action requise",
  officialIdentifiers: "Identifiants officiels",
  notExpired: "Non expiré",
  changeIdentity: "Remplacement de la pièce d'identité",
  contactDetails: "Coordonnées",
  mainMobileNumber: "Téléphone principal",
  secondaryMobileNumber: "Téléphone secondaire",
  taxationCompliance: "Fiscalité & conformité",
  declarationPEP: "Déclaration PEP",
  CountryOfTaxation: "Pays de résidence fiscale",
  TaxIDNumber: "TIN / N° fiscal",
  pep: "PEP",
  residentStatus: "Statut résident",
  residenceAddress: "Adresse de résidence",
  changeAddress: "Changement d'adresse",
  reference: "Référence",
  balance: "Solde",
  money: "Devise",
  rib: "RIB",
  openAt: "Ouvrir le",
  downloadRIB: "Télécharger le RIB",
  ribDownloading: "Génération du RIB...",
  ribDownloaded: "RIB téléchargé",
  ribDownloadError: "Impossible de télécharger le RIB",
  miniStatement: "Mini-relevé",
  viewMiniStatement: "Voir le mini-relevé",
  debit: "Débit",
  movementLabel: "Libellé",
  movementSense: "Sens",
  movementAmount: "Montant",
  movementBalanceAfter: "Solde après opération",
  noMovements: "Aucune écriture sur ce compte",
  miniStatementLoadError: "Impossible de charger le mini-relevé",
  customerDocuments: "Documents du client",
  expiration: "Expiration",
  reusable: "Réutilisable",
  RelatedRequest: "Demandes liées",
  civility: "Civilité",
  sectorActivity: "Secteur d'activité",
  comment: "Commentaire",
  contactForSavingCardCredit: "Contact épargne / carte / crédit",

  // Dashboard Page Not Ready
  dashboardPageNotReady: "Tableau de bord en cours de développement",
  dashboardPageNotReadyDescription:
    "Cette page est actuellement en cours de développement. Elle sera bientôt disponible avec des fonctionnalités complètes pour la gestion de votre tableau de bord",

  // Prospects & Client360 - Common
  all: "Tous",
  legalPerson: "Personne morale",
  moreCharacters: "de plus",
  start: "Début",
  end: "Fin",
  datePlaceholder: "dd/mm/yyyy",
  invalidAccountNumber: "Ce numéro de compte est invalide.",
  accountNumberExample: "Ex: 00XXXXXXXXXX",
  pageOf: "Page {0} sur {1}",
  searchAndFilterProspects: "Recherchez et filtrez les prospects",
  identityRepository: "Référentiel Identité",
  importCsv: "Importer CSV",
  newProspectRequest: "Nouvelle demande prospect",
  importing: "Importation...",
  importAction: "Enregistrer dans le référentiel",

  // Prospects - Status & Types
  eligible: "Eligible",
  toComplete: "To complete",
  refused: "Refused",
  duplicatePending: "Duplicate pending",
  web: "Web",
  branch: "Branch",
  corporate: "Corporate",
  clearScreening: "Clear",
  possible: "Possible",
  matchedSanction: "Matched sanction",
  noneScreening: "None",

  // Core Banking Columns
  clientCode: "Code client",
  lastNameColumn: "Nom",
  genderColumn: "Genre",
  nationalityColumn: "Nationalité",
  maritalStatusColumn: "Statut Marital",
  postalCodeColumn: "Code postal",
  phoneColumn: "Téléphone",
  lastUpdateAbbr: "MAJ",

  Voir: "Voir",
  minor: "Mineur",
  major: "Majeur",
  sinceAt: "Depuis le",
  viewer: "Visualiser",

  digits: "chiffres",
  maxPhoneCharactersMessage: "Le numéro de téléphone ne peut pas dépasser",
  minPhoneCharactersMessage: "Le numéro de téléphone doit comporter au moins",

  assignments: "Assignations",
  attributeRole: "Attribuer de rôle",
  noRolesFound: "Aucun rôle trouvé",
  rolesPerPage: "Rôles par page",

  // Administration
  featureComingSoon:
    "Cette fonctionnalité sera bientôt disponible en production.",
  rolesAndRights: "Rôles & Droits (RBAC)",
  rolesAndRightsDescription:
    "Administration des rôles, utilisateurs et paramètres de sécurité",
  newUser: "Nouvel utilisateur",
  newUserDialogTitle: "Ajouter un nouvel utilisateur manuellement",
  newUserDialogDescription:
    "Création d'un utilisateur sans synchronisation AD. Renseignez les informations d'identité.",
  editImportDescription:
    "Renseignez les informations pour l'enregistrement manuel d'un utilisateur.",
  phone1: "Téléphone principal",
  email1: "Email principal",
  phone2: "Téléphone secondaire",
  email2: "Email secondaire",
  chooseOrEnterEmail: "Choisir ou saisir un email",
  chooseOrEnterPhone: "Choisir ou saisir un numéro de téléphone",
  kycInformation: "Informations KYC",

  // fiche-client360 specific
  identityDocument: "Pièce d'identité",
  phoneNumbers: "Numéros de téléphone",
  primaryPhone: "Téléphone principal",
  secondaryPhone: "Téléphone secondaire",
  fax: "Fax",
  primaryEmail: "Email principal",
  secondaryEmail: "Email secondaire",
  emailAddresses: "Adresses email",
  noPhoneProvided: "Aucun numéro de téléphone renseigné",
  noEmailProvided: "Aucune adresse email renseignée",
  notDetermined: "Non déterminé",
  recentScreeningReports: "Rapports Screening récents",
  accountsOverview: "Comptes (aperçu)",
  viewAllAccounts: "Voir tous les comptes",
  complianceTitle: "Conformité",
  nextReKYC: "Prochaine Re-KYC",
  consentsSummary: "Consentements (résumé)",
  openConsentCenter: "Ouvrir Consent Center",
  noResult: "Aucun résultat",
  loadingError: "Erreur lors du chargement",
  title: "Titre",
  dataset: "Dataset",
  statusRating: "Statut/Rating",
  profileNotFound: "Profil introuvable",
  profileNotFoundDescription:
    "Le profil que vous recherchez n'existe pas ou a été supprimé.",
  notVerified: "Non vérifié",
  otpVerificationRequired:
    "La modification du téléphone ou de l'email nécessite une vérification par code OTP.",
  verificationCodeSent: "Code de vérification envoyé au",
  didNotReceiveCode: "Vous n'avez pas reçu le code ?",
  resendIn: "Renvoyer dans",
  resendCode: "Renvoyer le code",
  sendCode: "Envoyer le code",
  enterMinDigitsToReceiveCode:
    "Saisissez au moins 10 chiffres pour recevoir le code de vérification.",
  enterValidEmailToReceiveCode:
    "Saisissez une adresse email valide pour recevoir le code de vérification.",
  verify: "Vérifier",

  // Client360 - access regeneration tooltip
  verify_contacts_before_regenerate_access:
    "Vérifiez l'email ou le téléphone du client pour activer la régénération de l'accès.",

  // Onboarding – validation errors
  onboarding_identityDocRequired:
    "Une pièce d'identité (CNI ou Passeport) est requise",
  onboarding_addressProofRequired: "Un justificatif de domicile est requis",
  onboarding_idInvalidUploadNew:
    "La pièce d'identité est invalide. Veuillez téléverser un nouveau document valide.",
  onboarding_applyOcrAndFillRequired:
    "Veuillez appliquer le formulaire OCR et renseigner tous les champs obligatoires.",
  onboarding_productsAccountsRequired:
    "Les informations de produits et comptes sont requises",
  onboarding_uploadRequiredDocsFirst:
    "Veuillez d'abord télécharger les documents requis",

  // Onboarding – toasts & submit
  onboarding_resubmit: "Re-soumettre",
  onboarding_submittedSuccess: "Onboarding soumis avec succès",
  onboarding_submitError:
    "Une erreur s'est produite lors de la soumission du formulaire",
  onboarding_businessKeyMissing: "BusinessKey manquant",
  onboarding_submitFailed: "Échec de soumission de l'onboarding",
  onboarding_productsSaveSuccess:
    "Sauvegarde des produits terminée avec succès !",
  onboarding_productsSaveSuccessDesc:
    "Les produits ont été sauvegardés et en cours de traitement.",
  onboarding_productsSaveFailed: "Échec de la sauvegarde des produits",
  onboarding_productsSaveFailedDesc:
    "Les produits n'ont pas pu être sauvegardés.",
  onboarding_productsSaving: "Sauvegarde des produits en cours...",
  onboarding_productsSavingDesc:
    "Veuillez patienter pendant que nous sauvegardons les produits.",
  onboarding_productsFetchFailed:
    "Échec lors de la récupération des informations produits & comptes",
  onboarding_productsFetchError:
    "Une erreur est survenue lors de la récupération des informations produits & comptes",
  onboarding_identitySavedSuccess:
    "Informations d'identité sauvegardées avec succès",
  onboarding_identitySaveFailed:
    "Échec de la sauvegarde des informations d'identité",
  onboarding_metadataSavedSuccess: "Métadonnées sauvegardées avec succès",
  onboarding_metadataSaveFailed: "Échec de la sauvegarde des métadonnées",
  onboarding_metadataSaveError:
    "Une erreur est survenue lors de la sauvegarde des métadonnées",

  // UserProfile
  roles: "Rôles",
  lastConnection: "Dernière connexion",
  profileCreatedAt: "Crée le - MAJ",
  permission: "Permissions (aperçu)",
  recentActivities: "Activité récente",
  action: "Action",
  inactivate: "Désactiver",
  activate: "Activer",

  // Onboarding - Document Card
  removeFile: "Supprimer le document",
  removeFileDescription:
    "Voulez-vous vraiment supprimer ce document ? Cette action est irréversible.",
  confirm: "Confirmer",
  deleting: "Suppression...",

  // Roles Matrix
  preCheckSoD: "Pré-check SoD",
  roleName: "Nom du rôle",
  roleNamePlaceholder: "Ex: Rôle de gestion de la filiale",
  purpose: "Finalité",
  purposePlaceholder: "Ex: Gestion de la filiale",
  scope: "Portée",
  permissionSelected: "Permissions sélectionnées",
  selected: "sélectionnée(s)",
  loadingPermissions: "Chargement des permissions…",
  domain: "Domaine",
  description: "Description",
  grant: "Accorder",
  preCheckSoDDescription:
    "Pré-check SoD automatique après modification des permissions.",
  noConflicts: "Aucun conflit détecté",
  conflict: "Conflit détecté",
  restart: "Relancer",
  noDetailsShown: "Aucun détails à afficher",
  usersList: "Liste des utilisateurs",
  addNewUser: "Ajouter un utilisateur",
  addNewUserDescription:
    "Recherchez l'utilisateur par son matricule pour pré-remplir ses informations, puis créez son utilisateur RBAC.",
  createUser: "Créer l'utilisateur",
  searchUser: "Rechercher le l'utilisateur",
  confirmCreation: "Confirmer la création",
  userEmail: "Email de l'utilisateur",
  searching: "Recherche...",
  userFound: "Utilisateur trouvé",
  selectedUser: "Utilisateur sélectionné",
  rbacId: "Identifiant RBAC (username)",
  usernameLettersNumbers: "Lettres, chiffres, points, tirets et underscores.",
  userWillBeCreatedInactive: "L'utilisateur sera créé avec le statut",
  withoutRoleAssigned: "et sans rôle assigné.",
  activeSOD: "SOD actifs",
  notAvailable: "Non disponible",
  na: "N/A",
  sodConflicts: "Conflits SoD détectés",
  sodConflictsDescription:
    "Ce rôle présente des conflits de séparation des devoirs. Une justification sera requise.",
  highCriticality: "Rôle à haute criticité",
  highCriticalityDescription:
    "Cette attribution nécessite une approbation manager et une justification écrite.",
  attribute: "Attribuer",
  justification: "Justification",
  justificationRequired:
    "La justification doit contenir au moins 10 caractères.",
  selectedUsers: "utilisateur(s) sélectionné(s)",
  noPermissions: "Aucune permission",
  showMore: "Voir plus",
  showLess: "Voir moins",
  owner: "Propriétaire",
  numberOfAssignments: "Nombre d'assignations",
  userFile: "Fiche utilisateur",
  userFileDescription: "Fiche utilisateur (résumé des rôles et permissions)",
  street: "Rue",
  bankInformation: "Informations bancaires",
  agencyCode: "Code agence",
  employmentType: "Type d'emploi",
  company: "Entreprise",
  otherInformation: "Autres informations",
  profilRating: "Score Profil",
  customerDetailsFromCoreBanking: "Détails du client depuis Core Banking.",
  importStep: "Mettre à jour les informations",

  // Commercial Dashboard (P1)
  commercialDashboard: "Tableau de bord commercial",
  volumeOnboardingInities: "Volume onboarding initiés",
  kpiProspectsCrees: "Prospects créés",
  kpiKycCompletion: "Taux complétion KYC (TTC)",
  kpiAvgTimeToCollect: "Délai moyen collecte",
  kpiConversionRate: "Taux conversion Prospect→Client",
  kpiCeMois: "Ce mois",
  kpiRetry: "Réessayer",
  kpiDataUnavailable: "Données temporairement indisponibles",
  kpiOutlierBadge: "⚠ {{count}} dossier(s) > 90j",
  kpiConversionTooltip: "Taux calculé sur prospects créés et convertis ce mois",
  kpiConversionSubLabel: "{{converted}} sur {{total}} convertis",
  kpiTipOnboardingVolume: "Nombre de dossiers d'entrée en relation ouverts sur la période et pas encore soumis à validation.",
  kpiTipKycCompletion: "Part des clients dont le dossier KYC a réellement été instruit : identité complétée et contrôle de conformité effectué. Un client repris du système bancaire sans ce parcours compte au dénominateur mais pas au numérateur.",
  kpiTipTimeToCollect: "Nombre moyen de jours entre l'ouverture d'un dossier et sa soumission. Les dossiers encore en cours sont comptés jusqu'à aujourd'hui.",
  kpiTipConversion: "Part des dossiers ouverts sur la période devenus clients. Les dossiers refusés pour conformité sont exclus du calcul.",
  kpiTipBranchSla: "Délai moyen, en jours, entre l'ouverture du dossier et l'activation du compte pour les clients activés sur la période.",
  kpiTipDocRejection: "Part des dossiers contrôlés dont au moins une pièce a été rejetée (qualité de lecture ou incohérence d'identité). Les simples avertissements de complétude ne sont pas comptés.",
  kpiTipRekycBacklog: "Dossiers de révision périodique arrivés à échéance. Indicateur en attente du module de révision KYC.",
  kpiTipCommercialVolume: "Nombre de comptes clients activés sur la période, tous conseillers confondus.",
  kpiTipTriage: "Nombre d'alertes de conformité en attente de qualification par un analyste.",
  kpiTipEddDelay: "Durée moyenne de traitement d'une vigilance renforcée, de son ouverture à sa décision.",
  kpiTipFalsePositive: "Part des alertes qualifiées qui se sont révélées sans correspondance réelle. Un taux élevé signale un filtrage trop large.",
  kpiTipBacklogAge: "Ancienneté moyenne, en jours, des alertes encore en attente de qualification.",
  kpiTipSodConformity: "Part des rôles publiés respectant la séparation des tâches, sans cumul de fonctions incompatibles.",
  kpiTipFourEyesSla: "Délai moyen de validation par le second valideur dans le circuit à quatre yeux.",
  kpiTipHighRiskCoverage: "Part des dossiers à risque déjà qualifiés par la conformité. Le reste attend encore une décision.",
  kpiTipSodDerogation: "Nombre de dérogations à la séparation des tâches approuvées sur la période.",
  kpiTipTriggerLabel: "En savoir plus sur cet indicateur",
  kpiConvertedSubLabel: "{{converted}} sur {{total}} convertis",
  kpiDays: "j",
  kpiHours: "h",
  kpiActiveEddCasesSubLabel: "{{count}} dossier(s) en cours",
  kpiTrendUp: "En hausse",
  kpiTrendDown: "En baisse",

  // Dashboards — menu section & persona titles / breadcrumbs
  dashboardsSection: "Tableaux de bord",
  dashboardCommercial: "Commercial (P1)",
  dashboardAgence: "Agence (P2)",
  dashboardCompliance: "Compliance (P3)",
  dashboardConformite: "Conformité (P4)",
  dashboardCommercialSubtitle:
    "Suivi de l'activité commerciale et de la qualité d'onboarding",
  dashboardAgenceSubtitle:
    "Pilotage des ouvertures de compte et de la production de l'agence",
  dashboardComplianceSubtitle:
    "Productivité du triage des alertes AML/CFT et qualité des contrôles",
  dashboardConformiteSubtitle: "Conformité SoD, couverture EDD et dérogations",
  agence: "Agence",

  // KPI — unavailable tile
  kpiComingSoon: "Bientôt disponible",
  kpiComingSoonDescription: "Cet indicateur n'est pas encore disponible.",

  // KPI — P1 conversion drill-down card
  kpiConversionDrillDownCta: "Voir les prospects à convertir",

  // KPI — P2 (Agence)
  kpiBranchSla: "Délai moyen ouverture compte",
  kpiBranchSlaSubLabel: "{{count}} comptes ouverts",
  kpiDocRejection: "Taux de rejet documentaire",
  kpiDocRejectionSubLabel: "{{rejected}}/{{total}} documents rejetés",
  kpiCommercialVolume: "Volume de production commerciale",
  kpiCommercialVolumeSubLabel: "Comptes ouverts sur la période",
  kpiRekycBacklog: "Backlog Re-KYC",

  // KPI — P3 (Compliance)
  kpiTriageProductivity: "Productivité de triage",
  kpiTriageSubLabel: "{{count}} alertes en cours",
  kpiEddDelay: "Délai moyen traitement EDD",
  kpiFalsePositiveRate: "Taux de faux positifs",
  kpiFalsePositiveSubLabel: "{{clear}}/{{total}} évalués",
  kpiBacklogAge: "Âge moyen du backlog",

  // KPI — P4 (Conformité)
  kpiSodConformity: "Taux de conformité SoD",
  kpiSodConformitySubLabel: "{{compliant}}/{{total}} rôles conformes",
  kpiFourEyesSla: "SLA validation 4-yeux",
  kpiHighRiskCoverage: "Couverture EDD HR/PEP",
  kpiHighRiskCoverageSubLabel: "{{covered}}/{{total}} clients couverts",
  kpiHighRiskUncoveredPill: "{{count}} clients sans EDD valide",
  kpiSodDerogation: "Volume de dérogations SoD",
  kpiSodDerogationSubLabel: "{{count}} dérogations accordées",
  userMatricule: "Matricule utilisateur",
  function: "Fonction",
  departement: "Département",

  assigningRoleToUsers: "Attribution de rôle aux utilisateurs en cours...",
  roleAssignedSuccessfully: "Attribution de rôle aux utilisateurs réussie",
  roleAssignedSuccessfullyDescription: "Le rôles a été attribué avec succès.",
  revokeRole: "Révoquer le rôle",
  revokeRoleConfirmTitle: "Révoquer le rôle",
  revokeRoleConfirmDescription:
    "Cette action retire le rôle à l'utilisateur et est irréversible. Veuillez justifier cette révocation.",
  revokingRole: "Révocation du rôle en cours...",
  roleRevokedSuccessfully: "Rôle révoqué avec succès",
  roleRevokedSuccessfullyDescription:
    "Le rôle a été retiré de l'utilisateur avec succès.",

  civilStatusAndCapacity: "État civil & capacité",
  changeCivilStatus: "Changement d'état civil",
  addLegalRepresentative: "Ajout représentant légal",
  civilStatusLabel: "État civil",
  legalCapacity: "Capacité juridique",
  legalReferent: "Référent légal",
  fatherFirstNames: "Prénoms du père",
  motherFirstNames: "Prénoms de la mère",
  deathDate: "Date de décès",
  socioProfessionalSituation: "Situation socio-professionnelle",
  updateIncomeEmployer: "Mise à jour revenu et employeur",
  professionCountry: "Pays de profession",
  clientQuality: "Qualité client",
  monthlyRemuneration: "Rémunération mensuelle",
  bceaoSocioProNote:
    "Règle BCEAO : la catégorie est distincte de la profession. Ces données alimentent le profil de risque et la périodicité Re-KYC.",
  matrimonialAndFamily: "Régime matrimonial & famille",
  changeFamilySituation: "Changement de situation familiale",
  matrimonialRegime: "Régime matrimonial",
  marriageContract: "Contrat de mariage",
  spouseLastName: "Nom du conjoint",
  spouseFirstName: "Prénoms du conjoint",
  belongingAndBanking: "Appartenance & bancarisation",
  relationOtherInstitutions: "Relation avec d'autres établissements",
  bankPersonnel: "Personnel de la banque",

  patrimoineRealEstateAssets: "Actifs immobiliers",
  patrimoineRealEstateAssetsHint: "Appartements, maisons, terrains, …",
  patrimoineHowManyProperties: "Combien de biens ?",
  patrimoineAssetsInsured: "Les biens sont-ils assurés ?",
  patrimoineEstimatedValue: "Valeur estimée",
  patrimoineOtherBankAccounts: "Autres comptes bancaires",
  patrimoineOtherBankAccountsHint: "Compte courant, épargne, …",
  patrimoineTotalApproximateValue: "Valeur approximative totale",
  patrimoineValuableObjects: "Objets de valeur",
  patrimoineValuableObjectsHint: "Bijoux, art, …",
  patrimoineEdit: "Éditer",

  roleBlocked: "Rôle bloqué",
  roleBlockedDescription: "Ce rôle est bloqué et ne peut pas être publié.",

  commercial: "Commercial (P1)",
  conformite: "Conformité (P4)",
  thisMonth: "Ce mois",
  previousMonth: "Mois précédent",

  // Risk Entity Referential (US-6.5a)
  riskEntityReferential: "Référentiel de Scoring",
  riskEntityReferentialDescription:
    "Gérez les codes de niveau de risque par type d'entité.",
  riskEntityTabEntities: "Entités Risques",
  riskEntityTabWeighting: "Pondération",
  riskEntityWeightingDescription:
    "Chaque champ accepte une valeur entre 0 et 100 %. Les deux valeurs additionnées doivent faire exactement 100 %.",
  riskEntityWeightingSectionTitle:
    "Pondération Référentiel Identité et Contrôle externe",
  riskEntityWeightingSectionSubtitle:
    "Répartissez le poids relatif des deux sources externes dans le calcul du score client. Une répartition à 100 % garantit que le modèle reste équilibré et interprétable.",
  riskEntityWeightingCardTitle: "Saisie des pourcentages",
  riskEntityWeightingTotalLabel: "Total",
  riskEntityWeightingLseg: "Référentiel Identité",
  riskEntityWeightingVneurone: "Contrôle externe",
  riskEntityWeightingPercentHint: "Pourcentage (%)",
  riskEntityWeightingSubmitLoading: "Mise à jour en cours…",
  riskEntityWeightingValidate: "Mettre à jour",
  riskEntityWeightingSumMustBe100:
    "La somme Référentiel Identité + Contrôle externe doit être strictement égale à 100 %.",
  riskEntityWeightingInvalidPercent: "Saisissez un nombre valide.",
  riskEntityWeightingPercentRange:
    "Le pourcentage doit être compris entre 0 et 100.",
  riskEntityWeightingSubmittedSuccess: "Pondération enregistrée.",
  riskEntityWeightingConfigLoading: "Chargement de la pondération actuelle…",
  riskEntityWeightingReason: "Motif de la modification",
  riskEntityWeightingReasonPlaceholder:
    "Ex. bascule mode CONSERVATIVE — décision SteerCo 2026-07-15",
  riskEntityWeightingReasonRequired: "Le motif est obligatoire.",
  riskEntityWeightingReasonMinLength:
    "Le motif doit contenir au moins 5 caractères.",
  riskEntityWeightingHistorySheetTitle:
    "Historique — pondération Référentiel Identité / Contrôle externe",
  riskEntityWeightingHistorySheetSubtitle:
    "Chaque ligne correspond à une modification enregistrée (poids, auteur, motif).",
  riskEntityWeightingHistoryLoading: "Récupération de l'historique…",
  riskEntityWeightingHistoryEmpty: "Aucune entrée dans l'historique.",
  riskEntityWeightingHistoryColDate: "Date",
  riskEntityWeightingHistoryColAuthor: "Utilisateur",
  riskEntityWeightingHistoryColBefore: "Avant (Réf. Identité / Contrôle ext.)",
  riskEntityWeightingHistoryColAfter: "Après (Réf. Identité / Contrôle ext.)",
  riskEntityWeightingHistoryColReason: "Motif",
  entityType_OBJET_COMPTE: "Objet de compte",
  entityType_SOURCE_REVENU: "Source de revenu",
  entityType_PAYS: "Pays",
  entityType_PROFESSION: "Profession",
  entityType_ACTIVITE: "Activité",
  entityType_PRODUIT: "Produit",
  entityType_CANAL: "Canal",
  entityType_ANNEE_CONSTITUTION: "Année de constitution",
  riskLevel_RE: "RE — Risque Élevé",
  riskLevel_RM: "RM — Risque Modéré",
  riskLevel_RF: "RF — Risque Faible",
  riskEntityCode: "Code",
  riskEntityLibelle: "Libellé",
  riskEntityLevel: "Niveau",
  riskEntityActive: "Actif",
  riskEntityLastModified: "Dernière modification",
  riskEntityAddCode: "Ajouter un code",
  riskEntityEditLevel: "Modifier le niveau",
  riskEntityDeactivate: "Désactiver",
  riskEntityHistory: "Historique",
  riskEntityNewCode: "Nouveau code",
  riskEntityEditCode: "Modifier le code",
  riskEntityDeactivateTitle: "Désactiver ce code ?",
  riskEntityDeactivateDescription:
    "Le code sera masqué du scoring mais restera visible dans la table.",
  riskEntityRollbackTitle: "Restaurer cette version ?",
  riskEntityRollbackDescription:
    "Cette action appliquera l'état précédent et créera une entrée dans l'historique.",
  riskEntityRollbackConfirm: "Restaurer",
  riskEntityRestoreVersion: "Restaurer cette version",
  riskEntityChangeReason: "Motif de modification",
  riskEntityChangeReasonPlaceholder: "Indiquez le motif de ce changement…",
  riskEntityNoCodesFound: "Aucun code trouvé",
  riskEntityFilterByLevel: "Filtrer par niveau",
  riskEntityAllLevels: "Tous les niveaux",
  riskEntitySearchPlaceholder: "Rechercher un code ou libellé…",
  riskEntityStatusActive: "Actif",
  riskEntityStatusInactive: "Inactif",
  riskEntityHistoryAction_ADD: "Ajout",
  riskEntityHistoryAction_MODIFY: "Modification",
  riskEntityHistoryAction_DEACTIVATE: "Désactivation",
  riskEntityHistoryAction_ROLLBACK: "Restauration",
  riskEntityCreatedSuccess: "Code créé avec succès",
  riskEntityUpdatedSuccess: "Niveau mis à jour avec succès",
  riskEntityDeactivatedSuccess: "Code désactivé avec succès",
  riskEntityRolledBackSuccess: "Version restaurée avec succès",
  riskEntityOperationFailed: "L'opération a échoué. Veuillez réessayer.",
  riskEntityCodes: "code(s)",
  riskEntityModifyConfirmTitle: "Confirmer la modification",
  riskEntityNoHistory: "Aucun historique disponible pour ce type d'entité.",

  // Risk Entity Referential — CSV Import (US-6.5b)
  riskEntityImportCsv: "Importer CSV",
  riskEntityImportModalTitle: "Importer des codes via CSV",
  riskEntityImportDropzone:
    "Glissez un fichier .csv ici ou cliquez pour sélectionner",
  riskEntityImportDropzoneHint:
    "Format attendu : code,label,risk_level (UTF-8)",
  riskEntityImportSelectFile: "Sélectionner un fichier",
  riskEntityImportPreviewTitle: "Aperçu des modifications",
  riskEntityImportAdded: "Ajoutés",
  riskEntityImportModified: "Modifiés",
  riskEntityImportUnchanged: "Inchangés",
  riskEntityImportInvalid: "Invalides",
  riskEntityImportConfirmBtn: "Confirmer l'import",
  riskEntityImportSuccess:
    "Import appliqué : {applied} modifié(s), {added} ajouté(s), {errors} erreur(s)",
  riskEntityImportShowUnchanged: "Afficher les inchangés",
  riskEntityImportHideUnchanged: "Masquer les inchangés",
  riskEntityImportErrorReason: "Raison",
  riskEntityImportEmpty:
    "Le fichier est vide ou ne contient aucune ligne valide.",
  riskEntityImportFileTypeError:
    "Format non supporté. Veuillez sélectionner un fichier .csv.",
  riskEntityImportColumnCode: "Code",
  riskEntityImportColumnLabel: "Libellé",
  riskEntityImportColumnOldLevel: "Niveau actuel",
  riskEntityImportColumnNewLevel: "Nouveau niveau",
  riskEntityImportColumnStatus: "Statut",
  riskEntityImportChooseAnother: "Choisir un autre fichier",
  riskEntityImportConfirmCloseTitle: "Annuler l'import ?",
  riskEntityImportConfirmCloseDescription:
    "Le fichier analysé sera perdu. Vous devrez le sélectionner à nouveau.",

  // Risques Conformité — menu (libellés courts pour la sidebar ; titres de page plus descriptifs)
  risquesConformite: "Conformité & Risques",
  fileDeRevueL1: "File de Revue",
  validation4Yeux: "Reclassements",

  // EDD 4-yeux module
  eddTitle: "Diligence (EDD)",
  eddEmpty: "Aucun dossier EDD.",
  eddColBusinessKey: "ID client",
  eddColCustomer: "Client",
  eddColTrigger: "Déclencheur",
  eddColStatus: "Statut",
  eddColAnalyst: "Analyste",
  eddColCreatedAt: "Créé le",
  eddFilterAll: "Tous",
  eddFilterAssignedToMe: "Qui me sont assignés",
  eddStatus_OPEN: "Ouvert",
  eddStatus_IN_PROGRESS: "En cours",
  eddStatus_PENDING_L1: "En attente L1",
  eddStatus_PENDING_L2: "En attente L2",
  eddStatus_APPROVED: "Approuvé",
  eddStatus_REJECTED: "Rejeté",
  eddStatus_SUSPENDED: "Suspendu",
  eddTrigger_PEP: "PEP",
  eddTrigger_PEP_SANCTIONED: "PEP + pays sanctionné",
  eddTrigger_HIGH_RISK: "Risque élevé",
  eddTrigger_MANUAL: "Manuel",
  eddTrigger_ESCALATION_L1: "Escalade revue L1",
  eddTrigger_RE_KYC: "Re-KYC",
  eddTrigger_TRANSACTION_ALERT: "Alerte transaction",
  eddTrigger_UNKNOWN: "Autre",
  eddDocType_IDENTITY: "Pièce d'identité",
  eddDocType_SOURCE_OF_FUNDS: "Source des fonds",
  eddDocType_BUSINESS_ACTIVITY: "Activité professionnelle",
  eddDocType_BENEFICIAL_OWNER: "Bénéficiaire effectif",
  eddDocType_OTHER: "Autre",
  eddDocumentsTitle: "Pièces justificatives",
  eddNoDocuments: "Aucune pièce.",
  eddDownload: "Télécharger",
  eddPreview: "Aperçu",
  eddUploadTitle: "Ajouter une pièce",
  eddUploadType: "Type de pièce",
  eddUploadFile: "Fichier",
  eddUploadComment: "Commentaire (optionnel)",
  eddUploadSubmit: "Téléverser",
  eddHistoryTitle: "Historique",
  eddActionAddDocument: "Ajouter une pièce",
  eddActionSubmitL1: "Soumettre à la validation L1",
  eddActionSubmitL1Hint: "Au moins une pièce « Source des fonds » est requise.",
  eddActionAssign: "Prendre en charge",
  eddActionSuspend: "Suspendre",
  eddActionResume: "Reprendre",
  eddActionApproveL1: "Approuver (L1 agence)",
  eddActionApproveL2: "Approuver (L2 conformité)",
  eddActionApproveL2FourEyesHint:
    "Contrôle 4-yeux : le validateur L2 doit être différent du validateur L1.",
  eddActionReject: "Rejeter",
  eddRejectReason: "Motif du rejet",
  eddSuspendReason: "Motif de la suspension",
  eddMfaTitle: "Vérification de sécurité (MFA)",
  eddMfaSentTo: "Un code de validation a été envoyé à",
  eddMfaExpiresIn: "expire dans",
  eddMfaSendError: "Impossible d'envoyer le code de vérification. Réessayez.",
  eddMfaCodeLabel: "Code de vérification (6 chiffres)",
  eddMfaResend: "Renvoyer un code",
  eddMfaValidate: "Valider et confirmer",
  eddDecisionNotes: "Notes (optionnel)",
  eddApproveL2Title: "Valider (L2 conformité)",
  eddApproveL2RiskAssessment: "Réévaluation du risque",
  eddApproveL2Conclusion: "Conclusion (optionnel)",
  eddRisk_MAINTAINED: "Maintenu",
  eddRisk_UPGRADED: "Relevé",
  eddRisk_DOWNGRADED: "Abaissé",

  // L1 Review page (US 6.3)
  l1ReviewTitle: "File de revue L1",
  l1ReviewBusinessKey: "Business Key",
  l1ReviewCustomerName: "Nom",
  l1ReviewAssignedTo: "Attribué à",
  l1ReviewUnassigned: "Non attribué",
  l1ReviewRisk: "Risque",
  l1ReviewTabPending: "En attente",
  l1ReviewTabEscalated: "Escaladés",
  l1ReviewTabAuthorized: "Autorisés",
  l1ReviewTabRejected: "Rejetés",
  l1ReviewTabSlaBreached: "SLA dépassé",
  l1ReviewDetailTitle: "Détail du dossier de revue L1",
  l1ReviewDetailNotFound: "Dossier introuvable.",
  l1ReviewTriggerReason: "Motif de déclenchement",
  l1ReviewTrackAScore: "Score Référentiel Identité",
  l1ReviewTrackBScore: "Score contrôle externe",
  l1ReviewSlaDeadline: "Échéance SLA",
  l1ReviewSlaExpired: "SLA Expiré",
  l1ReviewAuthorize: "Autoriser",
  l1ReviewSuspend: "Suspendre",
  l1ReviewReject: "Rejeter",
  l1ReviewAssign: "S'attribuer",
  l1ReviewHeldBy: "Déjà attribué, seul son assigné peut le traiter",
  l1ReviewAssignHint: "Attribuez-vous le dossier pour pouvoir l'autoriser.",
  l1ReviewQualifyFirstHint:
    "Tranchez d'abord chaque correspondance : la décision se prend une fois établi s'il s'agit bien de la personne.",
  l1ReviewEscalate: "Escalader",
  l1ReviewSuspensionReason: "Motif de suspension",
  l1ReviewSuspensionReasonPlaceholder: "Décrivez le motif de suspension…",
  l1ReviewAuthorizeSuccess: "Dossier autorisé avec succès.",
  l1ReviewSuspendSuccess: "Dossier suspendu avec succès.",
  l1ReviewEscalateSuccess: "Dossier escaladé vers la validation P4.",
  l1ReviewActionFailed: "L'action a échoué. Veuillez réessayer.",
  l1ReviewEmpty: "Aucun dossier en attente de revue.",
  l1ReviewLoading: "Chargement des dossiers en attente…",
  l1ReviewLoadingError: "Échec du chargement des dossiers. Veuillez réessayer.",

  // P4 Validation page (US 4.5)
  p4ValidationTitle: "Reclassifications de risque (P4)",
  p4ValidationBusinessKey: "ID Client",
  p4ValidationOldClass: "Classe actuelle",
  p4ValidationNewClass: "Nouvelle classe",
  p4ValidationScoreDelta: "Δ Score",
  p4ValidationTrigger: "Motif",
  p4ValidationSlaDeadline: "Échéance SLA",
  p4ValidationSlaExpired: "SLA Expiré",
  p4ValidationFlaggedDirectionRisques: "Signalé : Direction Risques",
  p4ValidationApprove: "Approuver",
  p4ValidationReject: "Rejeter",
  p4ValidationJustification: "Justification",
  p4ValidationJustificationPlaceholder:
    "Fournissez une justification pour le rejet (min. 10 caractères)…",
  p4ValidationNotes: "Notes (facultatif)",
  p4ValidationNotesPlaceholder: "Notes complémentaires…",
  p4ValidationApproveSuccess:
    "Validation approuvée. Nouvelle classe de risque appliquée.",
  p4ValidationRejectSuccess:
    "Validation rejetée. Classe de risque actuelle conservée.",
  p4ValidationActionFailed:
    "L'action n'a pas pu aboutir. Veuillez réessayer dans un instant.",
  p4ValidationForbidden:
    "Vous n'avez pas les droits pour valider une reclassification de risque. Cette décision revient à un Responsable Conformité (P4).",
  p4ValidationSelfReviewForbidden:
    "Décision impossible : par principe des quatre yeux, la personne à l'origine du changement ne peut pas le valider elle-même. Un autre valideur doit s'en charger.",
  p4ValidationAlreadyDecided:
    "Cette reclassification a déjà été traitée par un autre valideur. La liste va se rafraîchir.",
  p4ValidationEmpty: "Aucune reclassification à valider pour le moment.",
  p4ValidationEmptyApproved: "Aucune reclassification approuvée à afficher.",
  p4ValidationEmptyRejected: "Aucune reclassification rejetée à afficher.",
  p4ValidationLoading: "Chargement des reclassifications…",
  p4ValidationLoadingError:
    "Échec du chargement des reclassifications. Veuillez réessayer.",
  p4ValidationPendingCount: "en attente de validation",
  // Filtre par statut + descriptions métier au-dessus de la liste
  p4StatusPending: "À valider",
  p4StatusApproved: "Approuvées",
  p4StatusRejected: "Rejetées",
  p4StatusDescPending:
    "Le niveau de risque de ces clients a changé (ex. passage Faible → Élevé). Un second valideur doit confirmer ou refuser ce changement avant qu'il ne devienne définitif. Le client reste actif pendant ce temps.",
  p4StatusDescApproved:
    "Changements de niveau de risque confirmés : le nouveau niveau a été appliqué au client. Historique en lecture seule.",
  p4StatusDescRejected:
    "Changements de niveau de risque refusés : le client conserve son niveau précédent. Les cas signalés sont transmis à la direction des risques pour suite à donner.",

  // Compliance triage — shared header, SLA countdown, queue summary, toolbar
  l1ReviewSubtitle:
    "Revue de niveau 1 des alertes de screening, triées par échéance.",
  p4ValidationSubtitle:
    "Double contrôle des changements de niveau de risque (Faible ↔ Élevé) sur les clients existants, triés par échéance.",
  eddSubtitle:
    "Dossiers de diligence renforcée en cours de traitement (4 yeux).",
  slaDueIn: "Échéance dans",
  slaOverdueSince: "Dépassée depuis",
  queueTotalPending: "En attente",
  queueDueSoon: "Échéance < 2 h",
  queueBreached: "SLA dépassé",
  queueFlaggedDR: "Signalés DR",
  eddQueueOpen: "Ouverts",
  eddQueuePendingL1: "Attente L1",
  eddQueuePendingL2: "Attente L2",
  eddRowClickHint: "Cliquez sur un dossier pour afficher son détail.",
  eddOpenCaseAria: "Ouvrir le dossier",
  eddDetailBack: "Retour aux dossiers",
  eddDetailCaseInfoTitle: "Informations du dossier",
  eddDetailSubmittedAt: "Soumis le",
  eddDetailL1ApprovedBy: "Validé L1 par",
  eddDetailL2ApprovedBy: "Validé L2 par",
  eddDetailSlaDeadline: "Échéance SLA",
  eddDetailNotFound: "Dossier introuvable.",
  eddCustomerDetailsTitle: "Détails du prospect",
  eddCustomerLoadError: "Impossible de charger les détails du prospect.",
  eddCustomerDocumentsTitle: "Documents du client",
  eddCustomerNoDocuments: "Aucun document.",
  eddCustomerDocColType: "Type",
  eddCustomerDocColName: "Document",
  eddCustomerDocColExpiration: "Expiration",
  eddCustomerDocView: "Voir",
  complianceSearchBusinessKey: "Business key",
  complianceFilterTrigger: "Motif",
  complianceFlaggedOnly: "Signalés DR uniquement",
  p4ValidationRiskChange: "Changement de classe",
  l1AuthorizeConfirmTitle: "Autoriser cette revue ?",
  l1AuthorizeConfirmBody:
    "La revue sera autorisée et retirée de la file. Cette action est définitive.",
  l1EscalateConfirmTitle: "Escalader cette revue ?",
  l1EscalateConfirmBody:
    "La revue sera escaladée vers la validation P4. Cette action est définitive.",

  // Les deux pistes sont nommées par ce qu'elles sont pour la banque, jamais par le prestataire
  // qui les alimente : le nom d'un fournisseur AML n'a pas à sortir sur un écran métier, et il
  // changerait à chaque bascule de provider alors que la lecture du verdict, elle, ne change pas.
  cvTrackA: "Référentiel Identité",
  cvTrackB: "Contrôle externe",
  cvFinalDecision: "Décision finale",
  cvWeights: "Pondérations",
  cvDecidedBy: "Tranché par",
  cvScoringWeights: "Pondérations du scoring",
  cvCanCreate: "Création autorisée",
  cvCannotCreate: "Création bloquée",
  cvVerdictHold: "En revue",
  cvVerdictUnknown: "Statut inconnu",
  cvHoldPending:
    "Prospect enregistré, aucun compte ouvert tant que la revue n'est pas levée",
  cvBlockingReason: "Motif de blocage",
  cvVNeuroneMode: "Mode contrôle externe",
  cvComputedAt: "Calculé le",
  cvVerdictClean: "Propre",
  cvVerdictWait: "En attente",
  cvVerdictFlagged: "Signalé",
  cvVerdictBlocked: "Bloqué",
  cvVerdictManualReview: "Revue manuelle",
  cvPendingOver48h: "En attente depuis plus de 48h",
  cvScreeningDetails: "Détails du screening",
  cvLoadError: "Impossible de charger le verdict.",

  additionalInformationKYC: "Informations complémentaires KYC",
  additionalInformationKYCDescription:
    "Mettez à jour les informations complémentaires du client.",
  financialSituationSection: "Situation financière",
  pepStatusSection: "Statut PPE",
  effectiveBeneficiarySection: "Bénéficiaire effectif",
  wealthSituation: "Situation patrimoniale",
  sourceOfFunds: "Source des fonds",
  bankRelationPurpose: "Objet de la relation bancaire",
  taxResidenceCountry: "Résidence fiscale (pays)",
  pepFunctionExercised: "Fonction PPE exercée",
  effectiveBeneficiary: "Bénéficiaire effectif",
  effectiveBeneficiaryIdentity: "Identité du bénéficiaire effectif",
  placeholderWealthSituation: "Ex : bien immobilier, épargne, placements",
  placeholderSourceOfFunds: "Ex : salaire, héritage, cession d'actif",
  placeholderBankRelationPurpose:
    "Ex : épargne, opérations courantes, virements internationaux",
  placeholderTaxResidenceCountry: "Ex : Côte d'Ivoire",
  placeholderPepFunction: "Ex : ministre, député, magistrat…",
  placeholderEffectiveBeneficiaryIdentity:
    "Ex : nom complet et qualité du bénéficiaire",
  immatriculationsSectionTitle: "Immatriculations",
  taxIdentifiersSectionTitle: "Identifiants fiscaux",
  addImmatriculation: "Ajouter une immatriculation",
  addTaxIdentifier: "Ajouter un identifiant fiscal",
  removeImmatriculation: "Retirer",
  removeTaxIdentifier: "Retirer",
  registryType: "Type de registre",
  registryTypeRCCM: "RCCM",
  registryTypeOther: "Autre",
  immatriculationNumber: "Numéro d'immatriculation",
  immatriculationDate: "Date d'immatriculation",
  immatriculationStatus: "Statut de vérification",
  statusVerified: "Vérifié",
  statusNotVerified: "Non vérifié",
  statusInProgress: "En cours",
  statusToReverify: "À revérifier",
  registrationSyncedReadOnly:
    "Ajouté au dossier. Le statut de vérification est décidé par la conformité, avec preuve à l'appui.",
  justificationAlternative: "Justification alternative",
  pendingComplianceValidation: "À valider conformité",
  taxIdentifierType: "Type d'identifiant fiscal",
  taxIdentifierTypeIFU: "IFU",
  taxIdentifierTypeNIF: "NIF",
  taxIdentifierTypeNINEA: "NINEA",
  taxIdentifierTypeOther: "Autre",
  taxIdentifierValue: "Valeur",
  immatriculationGateBlocked:
    "Ce dossier ne pourra pas être approuvé : aucune immatriculation vérifiée n'est enregistrée. Une justification alternative doit encore être validée par la conformité.",
  registrationVerificationDecide: "Décider",
  registrationVerificationTitle: "Décision de vérification",
  registrationVerificationTargetStatus: "Statut visé",
  registrationVerificationSource: "Source de vérification",
  registrationVerificationJustification: "Justification",
  registrationVerificationProofFile: "Preuve à déposer",
  registrationVerificationSubmit: "Enregistrer la décision",
  registrationVerificationCancel: "Annuler",
  registrationVerificationProofRequired:
    "Un fichier de preuve est obligatoire pour le statut Vérifié.",
  registrationVerificationPendingSync:
    "Enregistrez d'abord le dossier pour pouvoir décider de la vérification.",
  registrationVerificationError:
    "La décision n'a pas pu être enregistrée. Vérifiez les informations et réessayez.",

  ocrChangeCriticalTitle: "Modification d'une information d'identité",
  ocrChangeCriticalIntro:
    "Vous êtes sur le point de modifier des informations qui identifient le client :",
  ocrChangeCriticalConsequence:
    "Ces informations relancent le contrôle de conformité du client et sont enregistrées à votre nom. Vérifiez qu'elles correspondent bien à la pièce présentée.",
  ocrChangeCriticalAttestation:
    "Je confirme avoir vérifié ces informations sur la pièce d'identité originale",
  ocrChangeReasonLabel: "Motif de la modification",
  ocrChangeReasonPlaceholder:
    "Ex. : erreur de lecture OCR corrigée d'après la pièce présentée",
  ocrChangeSensitiveTitle: "Informations modifiées par la nouvelle lecture",
  ocrChangeSensitiveIntro:
    "La nouvelle lecture de la pièce modifie les informations suivantes :",
  ocrChangeNewCaptureTitle: "Informations détectées sur la pièce",
  ocrChangeNewCaptureIntro:
    "La lecture de la pièce a détecté les informations suivantes, pas encore renseignées sur ce dossier. Vérifiez qu'elles sont correctes avant de continuer :",
  ocrChangeDetectedValue: "Valeur détectée",
  ocrChangeAlsoChanged: "Également modifié :",
  ocrChangeLegalAgeWarning:
    "Cette date fait passer le client de mineur à majeur (ou l'inverse) : la liste des pièces exigées pour ce dossier va changer.",
  ocrChangeIdPaperWarning:
    "Si ce numéro de pièce est déjà enregistré sur un autre client, la modification sera refusée.",
  ocrChangeBefore: "Avant",
  ocrChangeAfter: "Après",
  ocrChangeCancel: "Annuler",
  ocrChangeConfirm: "Confirmer la modification",
  ocrChangeFieldLastName: "Nom",
  ocrChangeFieldFirstName: "Prénom",
  ocrChangeFieldBirthDate: "Date de naissance",
  ocrChangeFieldIdPaperNumber: "Numéro de la pièce",
  ocrChangeFieldNni: "NNI",
  ocrChangeFieldNationality: "Nationalité",
  ocrChangeFieldBirthPlace: "Lieu de naissance",
  ocrChangeFieldGender: "Sexe",
  ocrChangeFieldDeliveryDate: "Date de délivrance",
  ocrChangeFieldValidityDate: "Date d'expiration",
  staffDirectoryTitle: "Annuaire du personnel",
  staffDirectoryBranch: "Agence de rattachement",
  staffDirectoryEmail: "Email transmis au criblage",
  staffDirectoryNoBranch:
    "Aucune agence de rattachement dans l'annuaire du personnel. Les dossiers que vous ouvrez partent sans conseiller ni agence et ne sont pas criblés : faites créer votre rattachement avant de saisir un nouveau client.",
  staffDirectoryAmbiguousBranch:
    "Plusieurs agences de rattachement dans l'annuaire du personnel : aucune ne peut être retenue. Les dossiers que vous ouvrez ne sont pas criblés tant qu'il n'en reste qu'une.",
  staffDirectoryBranchCount: "Agences rattachées",
    accountOpeningRecapDecision: "DÃ©cision",
    accountOpeningRecapRepresentatives: "ReprÃ©sentants",
    accountOpeningRecapRiskLevel: "Niveau de risque",
    decisionJustificationLabel: "Justification",
    decisionMakerNameLabel: "Agent dÃ©cisionnaire",
    decisionOutcomeLabel: "Issue",
    decisionOutcomeRequestAdditionalInfo: "Demande de complÃ©ment",
    decisionTitle: "DÃ©cision KYB",
    pmScreeningLaunchButton: "Lancer le screening",
    pmScreeningNoHitsMessage: "Aucun hit dÃ©tectÃ©. Le screening est clear.",
    pmScreeningQualificationPending: "En attente",
    pmScreeningQualifyFalsePositive: "Faux positif",
    pmScreeningQualifyTruePositive: "Vrai positif",
    pmScreeningUnqualifiedHitsBlockMessage:
    "Chaque hit doit Ãªtre qualifiÃ© avant de continuer.",
    riskFactorScreeningHit: "Hit de screening confirmÃ©",
    riskLevelEleve: "Ã‰levÃ©",
    riskLevelFaible: "Faible",
    riskLevelModere: "ModÃ©rÃ©",
  
  stepDecision: "DÃ©cision",

  platformSettings: "Paramètres plateforme",
  platformSettingsDescription:
    "Activation des modules et bascules réservées à l'éditeur.",
  kybModuleToggleTitle: "Module KYB (onboarding personne morale)",
  kybModuleToggleDescription:
    "Active ou désactive l'onboarding personne morale (KYB) dans toute l'application : segment PM, dossiers KYB, écrans associés.",
  kybModuleToggleEnabled: "Actif",
  kybModuleToggleDisabled: "Inactif",
  kybModuleUnavailableTitle: "Module non actif",
  kybModuleUnavailableMessage:
    "Ce module n'est pas actif. Veuillez demander son activation dans votre abonnement.",
  identityPolicyToggleTitle: "Motif obligatoire sur la modification d'identité",
  identityPolicyToggleDescription:
    "Actif : toute modification d'un champ identifiant (nom, prénom, date de naissance, numéro de pièce, NNI, nationalité) exige un motif, refusée en 400 sinon. Inactif : le motif reste facultatif.",
  screeningPolicyPepTitle: "Blocage création sur hit PEP",
  screeningPolicyPepDescription:
    "Actif : un hit PEP Track A bloque la création du client jusqu'à EDD 4-yeux APPROVED.",
  screeningPolicyHighTitle: "Blocage création sur scoring HIGH",
  screeningPolicyHighDescription:
    "Actif : un scoring Track A = HIGH bloque la création et ouvre une revue L1 (soft-gate).",
  screeningPolicyVneuroneModeLabel: "Mode VNeurone",
  screeningPolicyProviderLabel: "Provider AML actif",
  secretEncryptionTitle: "Chiffrement de secret",
  secretEncryptionDescription:
    "Transforme une valeur en clair au format ENC(...) attendu par les .properties et les secrets Kubernetes, pour une rotation de clé.",
  secretEncryptionInputLabel: "Valeur en clair",
  secretEncryptionInputPlaceholder: "Coller la valeur à chiffrer",
  secretEncryptionButton: "Chiffrer",
  secretEncryptionOutputLabel: "Valeur chiffrée",
  secretEncryptionCopy: "Copier",
  secretEncryptionCopied: "Copié dans le presse-papiers",
  secretEncryptionError: "Échec du chiffrement. Réessayez.",
  customerPurgeTitle: "Purge client",
  customerPurgeDescription:
    "Supprime entièrement un client (base, identité Keycloak, objets MinIO) pour rejouer un test avec la même pièce et le même numéro. Irréversible.",
  customerPurgeBusinessKeyLabel: "BusinessKey du client",
  customerPurgeBusinessKeyPlaceholder: "Ex. aaa0087",
  customerPurgeButton: "Purger",
  customerPurgeConfirmTitle: "Confirmer la purge",
  customerPurgeConfirmDescription:
    "Cette action est irréversible : toutes les données du client seront supprimées.",
  customerPurgePasswordLabel: "Votre mot de passe",
  customerPurgePasswordPlaceholder: "Mot de passe",
  customerPurgeConfirmButton: "Confirmer la purge",
  customerPurgeSuccess: "Client purgé.",
  customerPurgeError: "Échec de la purge. Vérifiez le businessKey et votre mot de passe.",
  customerPurgeUnlockButton: "Déverrouiller",
  customerPurgeLockedHint: "Saisissez votre mot de passe pour déverrouiller cette zone.",
  customerPurgeBusinessKeyInvalid: "Format attendu : 3 lettres + 4 chiffres, ex. aaa0087.",

  agences: "Agences",
  agencesDescription: "Référentiel des agences - lecture seule.",
  agenceCode: "Code",
  agenceName: "Nom",
  agenceCity: "Ville",
  agenceAddress: "Adresse",
  agenceContact: "Contact",
  agenceCoordinates: "Coordonnées",
  agenceHours: "Horaires",
  agenceHoursOrdinary: "Semaine",
  agenceHoursSaturday: "Samedi",
  agenceHoursSunday: "Dimanche",
  agenceEmptyState: "Aucune agence trouvée.",
  agenceLoadError: "Impossible de charger le référentiel des agences.",
  subscriptionChannel: "Canal de souscription",
};

export default fr;
